module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "FRONT.VII"
    }
  }, [_c('p', {
    staticClass: "ctfm"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0005#rFRONT.VII"
    }
  }, [_vm._v("VII. Select Bibliography")])]), _vm._v(" "), _c('div', {
    staticClass: "references"
  }, [_c('p', {
    staticClass: "rf"
  }, [_vm._v("Abba, R. “The Origin and Significance of Hebrew Sacrifice,” "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.10"
    }
  }, [_vm._v("BTB")]), _vm._v(" 7 (1977) 123–38.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. “Priests and Levites in Deuteronomy,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.11"
    }
  }, [_vm._v("VT")])]), _vm._v(" 27 (1977) 257–67.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.18"
    }
  }), _vm._v("“Priests and Levites in Ezekiel,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.11"
    }
  }, [_vm._v("VT")])]), _vm._v(" 28 (1978) 1–9.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Aberbach, M., and L. Smolar. “Aaron, Jeroboam, and the Golden Calves,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.12"
    }
  }, [_vm._v("JBL")])]), _vm._v(" 86 (1967) 129–40.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Aharoni, Y. “The Province List of Judah,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.11"
    }
  }, [_vm._v("VT")])]), _vm._v(" 9 (1959) 225–46.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. “The Solomonic Temple, the Tabernacle and the Arad Sanctuary,” "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.13"
    }
  }, [_vm._v("AOAT")]), _vm._v(" 22 (1973) 1–8.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Aharoni, Y., and R. Amiran. “Arad: Its Inscriptions and Temple,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.14"
    }
  }, [_vm._v("BA")])]), _vm._v(" 31 (1968) 1–32.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Albright, W. F. “The Administrative Divisions of Israel and Judah,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.15"
    }
  }, [_vm._v("JPOS")])]), _vm._v(" 5 (1925) 17–54.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. “From the Patriarchs to Moses: 2. Moses out of Egypt,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.14"
    }
  }, [_vm._v("BA")])]), _vm._v(" 36 (1973) 57–58, 63–64.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. “The Home of Balaam,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.16"
    }
  }, [_vm._v("JAOS")])]), _vm._v(" 35 (1915) 386–90.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. “Jethro, Hobab and Reuel in Early Hebrew Tradition,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.17"
    }
  }, [_vm._v("CBQ")])]), _vm._v(" 25 (1963) 1–11.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. “The List of Levitic Cities.” In "), _c('i', [_vm._v("L. Ginzberg Jubilee Volume")]), _vm._v(". New York: American Academy for Jewish Research, 1945. Pp. 49–73.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. “Midianite Donkey Caravans.” In "), _c('i', [_vm._v("Translating and Understanding the Old Testament: Essays in Honor of Herbert Gordon May")]), _vm._v(". Ed. H. Frank and W. Reed. Nashville: Abingdon, 1970. Pp. 197–205.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. “The Oracles of Balaam,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.12"
    }
  }, [_vm._v("JBL")])]), _vm._v(" 63 (1944) 207–33.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. "), _c('i', [_vm._v("The Proto-Sinaitic Inscriptions and Their Decipherment")]), _vm._v(". Harvard Theological Studies 22. Cambridge: Harvard Univ., 1969.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Allegro, J. M. “The Meaning of the Phrase "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("šetm hā‘ayin")]), _vm._v(" in Num. 24:3, 15,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.11"
    }
  }, [_vm._v("VT")])]), _vm._v(" 3 (1953) 78–79.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Allen, R. B. “Numbers.” In "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.18"
    }
  }, [_vm._v("EBC")])]), _vm._v(" 2. Grand Rapids: Zondervan, 1990. Pp. 657–1008.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. “The Theology of the Balaam Oracles.” In "), _c('i', [_vm._v("Tradition and Testament: Essays in Honor of Charles Lee Feinberg")]), _vm._v(". Ed. J. S. Feinberg and P. D. Feinberg. Chicago: Moody, 1981. Pp. 79–119.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Allis, O. T. "), _c('i', [_vm._v("The Five Books of Moses")]), _vm._v(". Nutley, N.J.: Presbyterian & Reformed, 1941.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Alter, R. "), _c('i', [_vm._v("The Art of Biblical Narrative")]), _vm._v(". New York: Basic Books, 1981.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Ap-Thomas, D. R. “Some Notes on the Old Testament Attitude to Prayer,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.19"
    }
  }, [_vm._v("SJT")])]), _vm._v(" 9 (1956) 422–29.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Arden, E. “How Moses Failed God,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.12"
    }
  }, [_vm._v("JBL")])]), _vm._v(" 76 (1957) 50–52.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Auerbach, E. “Die Feste im alten Israel,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.11"
    }
  }, [_vm._v("VT")])]), _vm._v(" 8 (1958) 1–18.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. “Die Herkunft der Sadokiten,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.20"
    }
  }, [_vm._v("ZAW")])]), _vm._v(" 49 (1931) 327–28.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Auld, A. G. “Cities of Refuge in Israelite Tradition,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.21"
    }
  }, [_vm._v("JSOT")])]), _vm._v(" 10 (1978) 26–29.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. "), _c('i', [_vm._v("Joshua, Moses, and the Land: Tetrateuch, Pentateuch, Hexateuch in a Generation Since 1938")]), _vm._v(". Edinburgh: T. & T. Clark, 1980.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.19"
    }
  }), _vm._v("Avi-Yonah, M. "), _c('i', [_vm._v("The Encyclopedia of Archaeological Excavations in the Holy Land")]), _vm._v(". 4 vols. London: Oxford Univ. Press, 1975.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Baentsch, B. "), _c('i', [_vm._v("Exodus–Leviticus–Numeri")]), _vm._v(". "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.22"
    }
  }, [_vm._v("HKAT")]), _vm._v(" 2. Göttingen: Vandenhoeck & Ruprecht, 1903.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Bamberger, B. J. “Revelations of Torah after Sinai,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.23"
    }
  }, [_vm._v("HUCA")])]), _vm._v(" 16 (1941) 97–113.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Barnouin, M. “Les Rscensements du Livre des Nombres et l’Astronomie Babylonienne,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.11"
    }
  }, [_vm._v("VT")])]), _vm._v(" 27 (1977) 280–303.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. “Tableaux numériques du Livre des Nombres,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.24"
    }
  }, [_vm._v("RB")])]), _vm._v(" 76 (1969) 351–64.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Bartlett, J. R. “The Brotherhood of Edom,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.21"
    }
  }, [_vm._v("JSOT")])]), _vm._v(" 4 (1977) 2–27.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. “The Conquest of Sihon’s Kingdom: A Literary Re-examination,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.12"
    }
  }, [_vm._v("JBL")])]), _vm._v(" 97 (1978) 347–51.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. “The Historical Reference of Numbers 21:27–30,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.25"
    }
  }, [_vm._v("PEQ")])]), _vm._v(" 101 (1969) 94–100.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. “The Land of Seir and the Brotherhood of Edom,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.26"
    }
  }, [_vm._v("JTS")])]), _vm._v(" 20 (1969) 1–20.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. “The Moabites and Edomites.” In "), _c('i', [_vm._v("Peoples of Old Testament Times")]), _vm._v(". Ed. D. J. Wiseman. Oxford: Clarendon, 1973. Pp. 229–58.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. “The Rise and Fall of the Kingdom of Edom,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.25"
    }
  }, [_vm._v("PEQ")])]), _vm._v(" 104 (1972) 26–37.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. “Sihon and Og, Kings of the Amorites,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.11"
    }
  }, [_vm._v("VT")])]), _vm._v(" 20 (1970) 257–77.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. “The Use of the Word "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("rō’š")]), _vm._v(" as a Title in the Old Testament,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.11"
    }
  }, [_vm._v("VT")])]), _vm._v(" 19 (1969) 1–10.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. “Zadok and His Successors at Jerusalem,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.26"
    }
  }, [_vm._v("JTS")])]), _vm._v(" 19 (1968) 1–18.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Begrich, J. “Das priesterliche Heilsorakel,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.20"
    }
  }, [_vm._v("ZAW")])]), _vm._v(" 52 (1934) 81–92.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Beltz, W. "), _c('i', [_vm._v("Die Kaleb-Traditionen im Alten Testament")]), _vm._v(". "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.27"
    }
  }, [_vm._v("BWANT")]), _vm._v(" 98. Stuttgart: Kohlhammer, 1964.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Ben-Barek, Z. “Inheritance by Daughters in the Ancient Near East,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.28"
    }
  }, [_vm._v("JSS")])]), _vm._v(" 25 (1980) 22–33.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Bennett, C. “Excavations at Buseirah, Southern Jordan,” "), _c('i', [_vm._v("Levant")]), _vm._v(" 5 (1973) 1–11.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. “Tawilân,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.24"
    }
  }, [_vm._v("RB")])]), _vm._v(" 76 (1969) 386–90; 77 (1970) 371–74.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. “Ummel-Biyara-Pétra,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.24"
    }
  }, [_vm._v("RB")])]), _vm._v(" 71 (1964) 250–53; 73 (1966) 372–403.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Bentzen, A. “Zur Geschichte der Sadokiten,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.20"
    }
  }, [_vm._v("ZAW")])]), _vm._v(" NS 10 (1933) 173–76.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Bergmann, A. “The Israelite Tribe of Half Manasseh,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.15"
    }
  }, [_vm._v("JPOS")])]), _vm._v(" 16 (1936) 224–54.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Bertman, S. “Tasseled Garments in the Ancient East Mediterranean,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.14"
    }
  }, [_vm._v("BA")])]), _vm._v(" 24 (1961) 119–28.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Bewer, J. A. “The Literary Problems of the Balaam Story in Numbers, Chapters 22–24,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.29"
    }
  }, [_vm._v("AJT")])]), _vm._v(" 9 (1905) 238–62.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Binns, L. E. "), _c('i', [_vm._v("The Book of Numbers: With Introduction and Notes")]), _vm._v(". Westminster Commentaries. London: Methuen, 1927.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.20"
    }
  }), _vm._v("“Midianite Elements in Hebrew Religion,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.26"
    }
  }, [_vm._v("JTS")])]), _vm._v(" 31 (1930) 337–54.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Bird, P. “To Play the Harlot: An Inquiry into an Old Testament Metaphor.” In "), _c('i', [_vm._v("Gender and Difference in Ancient Israel")]), _vm._v(". Ed. P. Day. Minneapolis: Fortress, 1989. Pp. 75–94.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Blank, S. H. “The Curse, the Blasphemy, the Spell, and the Oath,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.23"
    }
  }, [_vm._v("HUCA")])]), _vm._v(" 23/1 (1950–51) 73–95.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. “Men against God—The Promethean Element in Biblical Prayer,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.12"
    }
  }, [_vm._v("JBL")])]), _vm._v(" 72 (1953) 1–14.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. “Some Observations concerning Biblical Prayer,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.23"
    }
  }, [_vm._v("HUCA")])]), _vm._v(" 32 (1961) 75–90.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Bodenheimer, F. W. “The Manna of Sinai,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.14"
    }
  }, [_vm._v("BA")])]), _vm._v(" 10 (1947) 1–6.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Boeker, H. J. "), _c('i', [_vm._v("Law and the Administration of Justice in the Old Testament and the Ancient East")]), _vm._v(". Tr. J. Moiser. Minneapolis: Augsburg, 1980.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Bowman, J. “Did the Qumran Sect Burn the Red Heifer?” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.30"
    }
  }, [_vm._v("RevQ")])]), _vm._v(" 1 (1958) 73–84.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Brenner, A. "), _c('i', [_vm._v("Colour Terms in the Old Testament")]), _vm._v(". "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.31"
    }
  }, [_vm._v("JSOTSup")]), _vm._v(" 21. Sheffield: "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.21"
    }
  }, [_vm._v("JSOT")]), _vm._v(" Press, 1982.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Brichto, H. C. “The Case of the "), _c('i', [_vm._v("Sota")]), _vm._v(" and a Reconsideration of Biblical Law,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.23"
    }
  }, [_vm._v("HUCA")])]), _vm._v(" 46 (1975) 55–70.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. “Kin, Cult, Land and Afterlife: A Biblical Complex,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.23"
    }
  }, [_vm._v("HUCA")])]), _vm._v(" 44 (1973) 1–54.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. "), _c('i', [_vm._v("The Problem of “Curse” in the Hebrew Bible")]), _vm._v(". Philadelphia: Society of Biblical Literature and Exegesis, 1962.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Brin, G. “The Formula ‘From . . . and Onward/Upward,’ ” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.12"
    }
  }, [_vm._v("JBL")])]), _vm._v(" 99 (1980) 351–54.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. “Numbers XV 22–23 and the Question of the Composition of the Pentateuch,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.11"
    }
  }, [_vm._v("VT")])]), _vm._v(" 30 (1980) 351–54.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Brown, F., S. R. Driver, and C. A. Briggs. "), _c('i', [_vm._v("A Hebrew-English Lexicon of the Old Testament")]), _vm._v(". Oxford: Clarendon, 1907.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Brueggemann, W. “From Hurt to Joy, from Death to Life,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.32"
    }
  }, [_vm._v("Int")])]), _vm._v(" 28 (1974) 3–19.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Buchanan, G. W. “Eschatology and the ‘End of Days,’ ” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.33"
    }
  }, [_vm._v("JNES")])]), _vm._v(" 20 (1961) 188–93.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Budd, P. J. "), _c('i', [_vm._v("Numbers")]), _vm._v(". "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.34"
    }
  }, [_vm._v("WBC")]), _vm._v(" 5. Waco, Tex.: Word, 1984.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Buis, P. “Les Conflits entre Moise et Israël dans Exode et Nombres,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.11"
    }
  }, [_vm._v("VT")])]), _vm._v(" 28 (1978) 257–70.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. “Qadesh, un Lieu Maudit?” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.11"
    }
  }, [_vm._v("VT")])]), _vm._v(" 24 (1974) 268–85.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Buit, M. du. “Quelques contacts bibliques dans les archives royales de Mari,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.24"
    }
  }, [_vm._v("RB")])]), _vm._v(" 66 (1959) 576–81.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Burns, R. J. "), _c('i', [_vm._v("Has the Lord Indeed Spoken Only Through Moses? A Study of the Biblical Portrait of Miriam")]), _vm._v(". "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.35"
    }
  }, [_vm._v("SBLDS")]), _vm._v(" 84. Atlanta: Scholars Press, 1987.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.21"
    }
  }), _vm._v("Burrows, E. "), _c('i', [_vm._v("The Oracles of Jacob and Balaam")]), _vm._v(". London: Burns, Oates and Washbourne, 1938.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Buttrick, G. A., et al., eds. "), _c('i', [_vm._v("The Interpreter’s Dictionary of the Bible")]), _vm._v(". 4 vols. Nashville: Abingdon, 1962. "), _c('i', [_vm._v("Supplementary Volume")]), _vm._v(". Ed. K. Crim, et al. 1976.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Canney, M. A. “Numbers 22:21–31,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.36"
    }
  }, [_vm._v("ExpTim")])]), _vm._v(" 27 (1917) 568.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Cassuto, U. "), _c('i', [_vm._v("The Documentary Hypothesis")]), _vm._v(". Tr. I. Abrahams. Jerusalem: Magnes, 1961.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Cazelles, H. “David’s Monarchy and the Gibeonite Claim,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.25"
    }
  }, [_vm._v("PEQ")])]), _vm._v(" 87 (1955) 165–75.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. “La Dîme Israélite et les Textes de Ras Shamra,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.11"
    }
  }, [_vm._v("VT")])]), _vm._v(" 1 (1951) 131–34.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Cheyne, T. K. “Some Critical Difficulties in the Chapters on Balaam,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.36"
    }
  }, [_vm._v("ExpTim")])]), _vm._v(" 10 (1898–99) 399–402.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Childs, B. S. “The Etiological Tale Re-examined,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.11"
    }
  }, [_vm._v("VT")])]), _vm._v(" 24 (1974) 387–97.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Christensen, D. L. “Num. 21:14–15 and the Book of the Wars of Yahweh,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.17"
    }
  }, [_vm._v("CBQ")])]), _vm._v(" 36 (1974) 359–60.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Clark, R. E. D. “The Large Numbers in the Old Testament,” "), _c('i', [_vm._v("Journal of the Transactions of the Victoria Institute")]), _vm._v(" 87 (1955) 82–92.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Clines, D. J. A. "), _c('i', [_vm._v("The Theme of the Pentateuch")]), _vm._v(". "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.31"
    }
  }, [_vm._v("JSOTSup")]), _vm._v(" 10. Sheffield: "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.21"
    }
  }, [_vm._v("JSOT")]), _vm._v(" Press, 1978.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Coats, G. W. “Balaam: Sinner or Saint?” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.37"
    }
  }, [_vm._v("BR")])]), _vm._v(" 18 (1973) 21–29.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. “Conquest Traditions in the Wilderness Theme,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.12"
    }
  }, [_vm._v("JBL")])]), _vm._v(" 95 (1976) 177–90.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. “An Exposition of the Wilderness Traditions,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.11"
    }
  }, [_vm._v("VT")])]), _vm._v(" 22 (1972) 288–95.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. “Legendary Motifs in the Moses Death Reports,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.17"
    }
  }, [_vm._v("CBQ")])]), _vm._v(" 39 (1977) 34–44.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. “Moses in Midian,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.12"
    }
  }, [_vm._v("JBL")])]), _vm._v(" 92 (1973) 3–10.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. "), _c('i', [_vm._v("The Murmuring Motif in the Wilderness Traditions of the Old Testament: Rebellion in the Wilderness")]), _vm._v(". Nashville: Abingdon, 1968.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. “The Wilderness Itinerary,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.17"
    }
  }, [_vm._v("CBQ")])]), _vm._v(" 34 (1972) 135–52.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. “The Way of Obedience: Traditio-Historical and Hermeneutical Reflections on the Balaam Story,” "), _c('i', [_vm._v("Semeia")]), _vm._v(" 24 (1982) 53–79.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Cody, A. "), _c('i', [_vm._v("A History of the Old Testament Priesthood")]), _vm._v(". "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.38"
    }
  }, [_vm._v("AnBib")]), _vm._v(" 35. Rome: Pontifical Biblical Institute, 1969.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Cook, F. C., and T. E. Espin. "), _c('i', [_vm._v("The Fourth Book of Moses Called Numbers")]), _vm._v(". The Holy Bible According to the Authorized Version. Vol. I/II. London: Murray, 1871.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Coppens, J. “Les Oracles de Bileam: Leur Origine Littéraire et leur Portée Prophétique.” In "), _c('i', [_vm._v("Mélanges Eugene Tisserant")]), _vm._v(". Ed. P. Hennequin et. al. Vol. 1. Cittá del Vaticano: Bibliotheca Apostolica Vaticana, 1964. Pp. 67–80.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.22"
    }
  }), _vm._v("Cox, S. "), _c('i', [_vm._v("Balaam: An Exposition and a Study")]), _vm._v(". London: Kegan Paul, Trench, 1884.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Craigie, P. C. “The Conquest and Early Hebrew Poetry,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.39"
    }
  }, [_vm._v("TynBul")])]), _vm._v(" 20 (1969) 76–94.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Cross, F. M. "), _c('i', [_vm._v("Canaanite Myth and Hebrew Epic")]), _vm._v(". Cambridge: Harvard Univ. Press, 1973.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. “The Priestly Tabernacle in the Light of Recent Research.” In "), _c('i', [_vm._v("Temples and High Places in Biblical Times; Proceedings of the Colloquium in Honor of the Centennial of Hebrew Union College-Jewish Institute of Religion")]), _vm._v(". Jerusalem: Nelson Glueck School of Biblical Archaeology, 1981. Pp. 170–72.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. “The Tabernacle,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.14"
    }
  }, [_vm._v("BA")])]), _vm._v(" 10 (1947) 1–68.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Cross, F. M., and G. E. Wright. “The Boundary and Province Lists of the Kingdom of Judah,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.12"
    }
  }, [_vm._v("JBL")])]), _vm._v(" 75 (1956) 202–26.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Daiches, S., “Balaam, a Babylonian "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("bārû")]), _vm._v(": The Episode of Num 22:2–24:24 and Some Babylonian Parallels,” "), _c('i', [_vm._v("Assyriologische und Archaeologische Studien Hermann von Hilprecht gewidmet")]), _vm._v(" (Leipzig: Hinrichs, 1909), pp. 60–70.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("David, M. “Die Bestimmungen über die Asylstädte in Jos. 20,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.40"
    }
  }, [_vm._v("OTS")])]), _vm._v(" 9 (1951) 30–48.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Davidson, A. B. "), _c('i', [_vm._v("Hebrew Syntax")]), _vm._v(". 3rd ed. Edinburgh: T. & T. Clark, 1902.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Davies, E. W. “Inheritance Rights and the Hebrew Levirate Marriage,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.11"
    }
  }, [_vm._v("VT")])]), _vm._v(" 31 (1981) 138–44.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Davies, G. I. "), _c('i', [_vm._v("The Way of the Wilderness: A Geographical Study of the Wilderness Itineraries in the Old Testament")]), _vm._v(". "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.41"
    }
  }, [_vm._v("SOTSMS")]), _vm._v(" 5. Cambridge: Cambridge Univ. Press, 1979.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. “The Wilderness Itineraries,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.39"
    }
  }, [_vm._v("TynBul")])]), _vm._v(" 25 (1974) 46–81.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Dever, W. G. “The EB IV–MB I Horizon in Transjordan and Southern Palestine,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.42"
    }
  }, [_vm._v("BASOR")])]), _vm._v(" 210 (1973) 37–63.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("De Vries, S. J. “The Origin of the Murmuring Tradition,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.12"
    }
  }, [_vm._v("JBL")])]), _vm._v(" 87 (1968) 51–58.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Digges, M. L. “Balaam: A Man in a Corner,” "), _c('i', [_vm._v("Bible Today")]), _vm._v(" 13 (1964) 869–74.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Dillmann, A. "), _c('i', [_vm._v("Die Bücher Numeri, Deuteronomium und Joshua")]), _vm._v(". Kurzgefasstes exegetisches Handbuch zum Alten Testament. 2nd ed. Leipzig: Hirzel, 1886.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Douglas, C. E. “The Twelve Houses of Israel,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.26"
    }
  }, [_vm._v("JTS")])]), _vm._v(" 37 (1936) 49–56.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Douglas, M. "), _c('i', [_vm._v("Purity and Danger: An Analysis of the Concepts of Pollution and Taboo")]), _vm._v(". London: Routledge and Kegan Paul, 1966.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Driver, G. R. “Two Problems in the Old Testament Examined in the Light of Assyriology,” "), _c('i', [_vm._v("Syria")]), _vm._v(" 33 (1956) 70–78.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———, and J. C. Miles. “Ordeal by Oath at Nuzi,” "), _c('i', [_vm._v("Iraq")]), _vm._v(" 7 (1940) 132.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.23"
    }
  }), _vm._v("Driver, S. R. "), _c('i', [_vm._v("Introduction to the Literature of the Old Testament")]), _vm._v(". 12th ed. Oxford: Clarendon, 1906.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. "), _c('i', [_vm._v("A Treatise on the Use of the Tenses in Hebrew and Some Other Syntactical Questions")]), _vm._v(". 2nd ed. Oxford: Clarendon, 1881.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Dumbrell, W. J. “Midian—A Land or a League?” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.11"
    }
  }, [_vm._v("VT")])]), _vm._v(" 25 (1975) 323–37.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Dus, J. “Herabfahrung Jahwes auf die Lade und Entziehung der Feuerwolke,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.11"
    }
  }, [_vm._v("VT")])]), _vm._v(" 19 (1969) 290–311.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Eichrodt, W. "), _c('i', [_vm._v("Theology of the Old Testament")]), _vm._v(". Tr. J. A. Baker. 2 vols. "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.43"
    }
  }, [_vm._v("OTL")]), _vm._v(". Philadelphia: Westminster, 1961–67.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Eising, H. “Balaams Eselin,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.44"
    }
  }, [_vm._v("BK")])]), _vm._v(" 13 (1958) 45–47.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Eissfeldt, O. "), _c('i', [_vm._v("Hexateuch-Synopse: Die Erzälung der fünf Bücher Mose und des Buches Josua mit dem Anfange des Richterbuches")]), _vm._v(". Leipzig: J. C. Hinrichs, 1922.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. “Die Komposition der Bileam-Erzählung,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.20"
    }
  }, [_vm._v("ZAW")])]), _vm._v(" 57 (1939) 212–41.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. "), _c('i', [_vm._v("The Old Testament: An Introduction")]), _vm._v(". Tr. P. Ackroyd. New York: Harper & Row, 1965.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. “Protektorat der Midianiter über ihre Nachbarn im letzten Viertel des 2. Jahrtausends v. Chr.,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.12"
    }
  }, [_vm._v("JBL")])]), _vm._v(" 87 (1968) 383–93.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. “Sinai Erzählung und Bileamsprüche,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.23"
    }
  }, [_vm._v("HUCA")])]), _vm._v(" 32 (1961) 179–90.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Elhorst, H. J. “Das Ephod,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.12"
    }
  }, [_vm._v("JBL")])]), _vm._v(" 30 (1910) 154–76.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Elliger, K. “Sinn und Ursprung der Priesterliche Geschichtserzählung,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.45"
    }
  }, [_vm._v("ZTK")])]), _vm._v(" 49 (1952) 121–43.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Emerton, J. A. “Priests and Levites in Deuteronomy,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.11"
    }
  }, [_vm._v("VT")])]), _vm._v(" 12 (1962) 129–38.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Engnell, I. “Methodological Aspects of Old Testament Study,” "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.46"
    }
  }, [_vm._v("VTSup")]), _vm._v(" 7. Leiden: Brill, 1960. Pp. 13–30.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. “The Pentateuch.” In "), _c('i', [_vm._v("Critical Essays on the Old Testament")]), _vm._v(". Tr. J. T. Willis. London: SPCK, 1970. Pp. 50–67.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. “The Traditio-Historical Method in Old Testament Research.” In "), _c('i', [_vm._v("Critical Essays on the Old Testament")]), _vm._v(". London: SPCK, 1970. Pp. 3–11")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. “Wilderness Wandering.” In "), _c('i', [_vm._v("Critical Essays on the Old Testament")]), _vm._v(". London: SPCK, 1970. Pp. 207–14.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Erdman, C. R. "), _c('i', [_vm._v("The Book of Numbers: An Exposition")]), _vm._v(". Westwood, N.J.: Revell, 1952.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Fensham, F. C. “Malediction and Benediction in Ancient Near Eastern Vassal-Treaties and the Old Testament,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.20"
    }
  }, [_vm._v("ZAW")])]), _vm._v(" 74 (1962) 1–9.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Fichtner, J. “Die etymologische Ätiologie in den Namengebungen der geschichtlichen Bücher des Alten Testament,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.11"
    }
  }, [_vm._v("VT")])]), _vm._v(" 6 (1956) 372–96.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Finesinger, S. B. “Musical Instruments in the Old Testament,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.23"
    }
  }, [_vm._v("HUCA")])]), _vm._v(" 3 (1926) 21–76.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. “The Shofar,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.23"
    }
  }, [_vm._v("HUCA")])]), _vm._v(" 8–9 (1931–32) 193–228.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.24"
    }
  }), _vm._v("Fisch, S. “The Book of Numbers.” In "), _c('i', [_vm._v("The Soncino Chumash: The Five Books of Moses with Haphtaroth")]), _vm._v(". Ed. A. Cohen. London: Soncino, 1947. Pp. 793–987.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Fishbane, M. “Accusations of Adultery: A Study of Law and Scribal Practice in Numbers 5:11–31,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.23"
    }
  }, [_vm._v("HUCA")])]), _vm._v(" 45 (1974) 25–46.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Fisher, L. R. “A New Ritual Calendar from Ugarit,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.47"
    }
  }, [_vm._v("HTR")])]), _vm._v(" 63 (1970) 485–501.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Flack, E. E. “Flashes of New Knowledge, Recent Study and the Book of Numbers,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.32"
    }
  }, [_vm._v("Int")])]), _vm._v(" 13 (1959) 3–23.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Flanagan, J. W. “History, Religion and Ideology: The Caleb Tradition,” "), _c('i', [_vm._v("Horizons")]), _vm._v(" 3 (1976) 175–85.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Fohrer, G. "), _c('i', [_vm._v("Introduction to the Old Testament")]), _vm._v(". Tr. D. Green. Nashville: Abingdon, 1968.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Foote, T. C. “The Ephod,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.12"
    }
  }, [_vm._v("JBL")])]), _vm._v(" 21 (1902) 1–47.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Franken, H. J. “Texts from the Persian Period from Tell Deir ‘Alla,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.11"
    }
  }, [_vm._v("VT")])]), _vm._v(" 17 (1967) 480–81.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Freedman, D. N. “Archaic Forms in Early Hebrew Poetry,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.20"
    }
  }, [_vm._v("ZAW")])]), _vm._v(" 72 (1960) 101–7.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. “Pottery, Poetry, and Prophecy: An Essay on Biblical Poetry,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.12"
    }
  }, [_vm._v("JBL")])]), _vm._v(" 96 (1977) 5–26.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Fretheim, T. E. “The Priestly Document: Anti-Temple?” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.11"
    }
  }, [_vm._v("VT")])]), _vm._v(" 18 (1968) 313–29.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Frick, F. S. "), _c('i', [_vm._v("The City in Ancient Israel")]), _vm._v(". "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.35"
    }
  }, [_vm._v("SBLDS")]), _vm._v(". Missoula, Mont.: Scholars Press, 1977.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Fritz, V. “Arad in der biblischen überlieferung und in der Liste Schoschenk I,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.48"
    }
  }, [_vm._v("ZDPV")])]), _vm._v(" 82 (1966) 331–42.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. “Erwägungen zur Siedlungsgeschichte des Negeb in der Eisen 1-Zeit (1200–1000 v.Chr.) im Lichte der Ausgrabungen auf der "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("Ḥirbet el-Mšaš")]), _vm._v(",” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.48"
    }
  }, [_vm._v("ZDPV")])]), _vm._v(" 91 (1975) 30–45.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. "), _c('i', [_vm._v("Israel in der Wüste: Traditionsgeschichtliche Untersuchungen der Wüstenüberlieferung des Jahwisten")]), _vm._v(". Marburg: Elwert, 1970.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Frymer-Kensky, T. “The Strange Case of the Suspected Sotah (Numbers V 13–31),” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.11"
    }
  }, [_vm._v("VT")])]), _vm._v(" 34 (1984) 11–26.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Gaster, T. H. “The Name "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("lēwî")]), _vm._v(",” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.26"
    }
  }, [_vm._v("JTS")])]), _vm._v(" 38 (1937) 250–51.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Gemser, B. “Der Stern au Jacob (Num. 24:17),” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.20"
    }
  }, [_vm._v("ZAW")])]), _vm._v(" 45 (1925) 301–2.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Gibson, J. C. L. "), _c('i', [_vm._v("Canaanite Myths and Legends")]), _vm._v(". 2nd ed. Edinburgh: T. & T. Clark, 1978.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Gillischewski, E. “Die Geschichte von der ‘Rotte Korah’ Num. 16,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.49"
    }
  }, [_vm._v("AfO")])]), _vm._v(" 3 (1926) 114–18.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Glueck, N. “The Boundaries of Edom,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.23"
    }
  }, [_vm._v("HUCA")])]), _vm._v(" 11 (1936) 141–57.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. “The Civilisation of the Edomites,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.14"
    }
  }, [_vm._v("BA")])]), _vm._v(" 10 (1947) 77–84.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Golka, F. W. “The aetiologies in the Old Testament,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.11"
    }
  }, [_vm._v("VT")])]), _vm._v(" 26 (1976) 410–28; 27 (1977) 36–47.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.25"
    }
  }), _vm._v("Gottwald, N. K. "), _c('i', [_vm._v("The Tribes of Yahweh")]), _vm._v(". Maryknoll, N.Y.: Orbis, 1979.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Gowan, D. E. “The use of "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("ya‘an")]), _vm._v(" in biblical Hebrew,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.11"
    }
  }, [_vm._v("VT")])]), _vm._v(" 21 (1971) 168–85.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Gradwohl, R. “Das ‘fremde Feuer’ von Nadab und Abihu,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.20"
    }
  }, [_vm._v("ZAW")])]), _vm._v(" 75 (1963) 288–96.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Gray, G. B. "), _c('i', [_vm._v("A Critical and Exegetical Commentary on Numbers")]), _vm._v(". "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.50"
    }
  }, [_vm._v("ICC")]), _vm._v(". Edinburgh: T. & T. Clark, 1903.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. “The Nazirite,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.26"
    }
  }, [_vm._v("JTS")])]), _vm._v(" 1 (1899–1900) 201–11.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. "), _c('i', [_vm._v("Sacrifice in the Old Testament")]), _vm._v(". Oxford: Clarendon, 1925.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Gray, J. “The Desert Sojourn of the Hebrews and the Sinai Horeb Tradition,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.11"
    }
  }, [_vm._v("VT")])]), _vm._v(" 4 (1954) 148–54.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. "), _c('i', [_vm._v("The Legacy of Canaan: The Ras Shamra Texts and Their Relevance to the Old Testament")]), _vm._v(". "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.46"
    }
  }, [_vm._v("VTSup")]), _vm._v(" 5. 2nd ed. Leiden: Brill, 1965.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Green, W. H. "), _c('i', [_vm._v("The Higher Criticism of the Pentateuch")]), _vm._v(". New York: Scribners, 1895.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Greenberg, M. “The Biblical Conception of Asylum,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.12"
    }
  }, [_vm._v("JBL")])]), _vm._v(" 78 (1959) 125–32.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. “Idealism and Practicality in Numbers 35:4–5 and Ezekiel 48,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.16"
    }
  }, [_vm._v("JAOS")])]), _vm._v(" 88 (1968) 59–66.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. “A New Approach to the History of the Israelite Priesthood,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.16"
    }
  }, [_vm._v("JAOS")])]), _vm._v(" 70 (1950) 41–46.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Greenstone, J. H. "), _c('i', [_vm._v("Numbers, with Commentary")]), _vm._v(". Philadelphia: Jewish Publication Society, 1948.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Gressmann, H. "), _c('i', [_vm._v("Mose und Seine Zeit")]), _vm._v(". Göttingen: Vandenhoeck & Ruprecht, 1913.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Gross, W. "), _c('i', [_vm._v("Bileam: Literar- und Formkritische Untersuchung der Prosa im Num. 22–24")]), _vm._v(". Munich: Kösel, 1974.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. “ ‘Ein Zepter wird sich erheben aus Israel’ (Num. 24:17): Die messianische Hoffnung im Alten Testament,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.44"
    }
  }, [_vm._v("BK")])]), _vm._v(" 17 (1962) 34–37.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Guillaume, A. “A Note on Num. 23:10,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.11"
    }
  }, [_vm._v("VT")])]), _vm._v(" 12 (1962) 335–37.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Gunn, D. M. “The ‘Battle Report’: Oral or Scribal Convention,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.12"
    }
  }, [_vm._v("JBL")])]), _vm._v(" 93 (1974) 513–18.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Gunneweg, A. H. J. "), _c('i', [_vm._v("Leviten und Priester")]), _vm._v(". Göttingen: Vandenhoeck & Ruprecht, 1965.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. “Mose in Midian,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.45"
    }
  }, [_vm._v("ZTK")])]), _vm._v(" 61 (1964) 1–9.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Guyot, G. H. “Balaam,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.17"
    }
  }, [_vm._v("CBQ")])]), _vm._v(" 3 (1941) 235–42.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. “The Prophecy of Balaam,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.17"
    }
  }, [_vm._v("CBQ")])]), _vm._v(" 2 (1940) 330–40.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Hackett, J. "), _c('i', [_vm._v("The Balaam Text from Deir")]), _vm._v(" "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("‘Allā")]), _vm._v(". "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.51"
    }
  }, [_vm._v("HSM")]), _vm._v(" 31. Chico, Calif.: Scholars Press, 1980.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. “Some Observations on the Balaam Text at Deir "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("‘Allā")]), _vm._v("” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.14"
    }
  }, [_vm._v("BA")])]), _vm._v(" 49 (1986) 216–22.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Halpern, B. “Levitic Participation in the Reform Cult of Jeroboam I,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.12"
    }
  }, [_vm._v("JBL")])]), _vm._v(" 95 (1976) 31–42.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.26"
    }
  }), _vm._v("Hanson, H. E. “Num. XVI 30 and the meaning of "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("bārā’")]), _vm._v(",” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.11"
    }
  }, [_vm._v("VT")])]), _vm._v(" 22 (1972) 353–59.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Haran, M. “From Early to Classical Prophecy: Continuity and Change,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.11"
    }
  }, [_vm._v("VT")])]), _vm._v(" 27 (1977) 385–97.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. “The Levitical Cities: Utopia and Historical Reality,” "), _c('i', [_vm._v("Tarbiz")]), _vm._v(" 27 (1957–58) 421–38.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. “The Nature of the ‘"), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("’ohel mo‘edh")]), _vm._v("’ in Pentateuchal Sources,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.28"
    }
  }, [_vm._v("JSS")])]), _vm._v(" 5 (1960) 50–65.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. “The Passover Sacrifice.” In "), _c('i', [_vm._v("Studies in the Religion of Ancient Israel")]), _vm._v(". "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.46"
    }
  }, [_vm._v("VTSup")]), _vm._v(" 23. Leiden: Brill, 1972. Pp. 86–116.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. “The Priestly Image of the Tabernacle,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.23"
    }
  }, [_vm._v("HUCA")])]), _vm._v(" 36 (1965) 191–226.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. “Studies in the Account of the Levitical Cities,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.12"
    }
  }, [_vm._v("JBL")])]), _vm._v(" 80 (1961) 45–54.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. "), _c('i', [_vm._v("Temples and Temple Service in Ancient Israel")]), _vm._v(". Oxford: Clarendon, 1978.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. “The Uses of Incense in the Ancient Israelite Ritual,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.11"
    }
  }, [_vm._v("VT")])]), _vm._v(" 10 (1960) 113–29.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Harrelson, W. “Guidance in the Wilderness: The Theology of Numbers,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.32"
    }
  }, [_vm._v("Int")])]), _vm._v(" 13 (1959) 24–36.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Harrison, R. K. "), _c('i', [_vm._v("Introduction to the Old Testament")]), _vm._v(". Grand Rapids: Eerdmans, 1969.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. "), _c('i', [_vm._v("Numbers")]), _vm._v(". "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.52"
    }
  }, [_vm._v("WEC")]), _vm._v(". Chicago: Moody, 1990.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Heinisch, P. "), _c('i', [_vm._v("Das Buch Numeri, übersetzt und Erklärt")]), _vm._v(". Die Heilige Schrift des Alten Testament. Bonn: Hanstein, 1936.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Hempel, J. “Die israelitischen Anschauungen von Segen und Fluch im Lichte altorientalische Parallelen.” In "), _c('i', [_vm._v("Apoxsymata: Vorarbeiten zu einer Religionsgeschichte und Theologie des Alten Testaments")]), _vm._v(". Festgabe J. Hempel. Ed. W. Baumgartner, et al. "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.53"
    }
  }, [_vm._v("BZAW")]), _vm._v(" 81. Berlin: Töpelmann, 1961. Pp. 30–113.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Henke, O. “Zur Lage von Beth Peor,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.48"
    }
  }, [_vm._v("ZDPV")])]), _vm._v(" 75 (1959) 155–63.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Hertz, J. H. “Numbers 23:9b, 10,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.36"
    }
  }, [_vm._v("ExpTim")])]), _vm._v(" 45 (1933–34) 524.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Hoftijzer, J. “The Prophet Balaam in a 6th Century Aramaic Inscription,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.14"
    }
  }, [_vm._v("BA")])]), _vm._v(" 39 (1976) 11–17.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Hoftijzer, J., and G. van der Kooij, eds. "), _c('i', [_vm._v("The Balaam Text from Deir")]), _vm._v(" "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("‘Alla")]), _vm._v(" "), _c('i', [_vm._v("Re-Evaluated: Proceedings of the International Symposium held at Leiden, 21–24 August 1989")]), _vm._v(". Leiden: Brill, 1990. ("), _c('i', [_vm._v("Proceedings")]), _vm._v(", 1989).")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———, eds. "), _c('i', [_vm._v("Aramaic Texts from Deir")]), _vm._v(" "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("‘Alla")]), _c('i', [_vm._v(". With Contributions by H. Franken, V. R. Mehra, J. Voskuil, J. A. Mosk. Preface by P. A. H. de Boer")]), _vm._v(". Documenta et Monumenta Orientis Antiqui 19. Leiden: Brill, 1976 ("), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.54"
    }
  }, [_vm._v("ATDA")])]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.27"
    }
  }), _vm._v("Holzinger, H. "), _c('i', [_vm._v("Numeri, Erklärt")]), _vm._v(". Kurzer Hand-Commentar zum Alten Testament 4. Tübingen: J. C. B. Mohr, 1903.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Hooke, S. H. “Theory and Practice of Substitution,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.11"
    }
  }, [_vm._v("VT")])]), _vm._v(" 2 (1952) 2–17.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Horne, S. H. “The Excavations at Tell Hesban, 1973,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.55"
    }
  }, [_vm._v("ADAJ")])]), _vm._v(" 18 (1973) 87–88.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Horst, F. “Recht und Religion im Bereich des A.T.,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.56"
    }
  }, [_vm._v("EvT")])]), _vm._v(" 16 (1956) 49–75.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Hort, G. “The Death of Qorah,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.57"
    }
  }, [_vm._v("AusBR")])]), _vm._v(" 7 (1959) 2–26.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Hurvitz, A. “Evidence of Language in Dating the Priestly Code: A Linguistic Study in Technical Terms and Terminology,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.24"
    }
  }, [_vm._v("RB")])]), _vm._v(" 81 (1974) 24–56.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Jacob, E. "), _c('i', [_vm._v("Theology of the Old Testament")]), _vm._v(". Tr. A. W. Heathcote and P. Allcock. New York: Harper & Row, 1958.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("James, E. O. "), _c('i', [_vm._v("The Ancient Gods: The History of the Diffusion of Religion in the Ancient Near East and the Eastern Mediterranean")]), _vm._v(". London: Weidenfeld and Nicholson, 1960.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Jirku, A. “Wo Stand Ursprünglich die Notiz über Hebron in Num. 13:22?” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.20"
    }
  }, [_vm._v("ZAW")])]), _vm._v(" 39 (1921) 312.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Jobling, D. “The Jordan a Boundary: A Reading of Numbers 32 and Joshua 22.” In "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.58"
    }
  }, [_vm._v("SBLSP")]), _vm._v(", 1980. Ed. P. J. Achtemeier. Chico, Calif.: Scholars Press, 1980. Pp. 183–207.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Johnson, A. R. "), _c('i', [_vm._v("The Cultic Prophet in Ancient Israel")]), _vm._v(". Cardiff: Univ. of Wales, 1962.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Joines, K. R. “The Bronze Serpent in the Israelite Cult,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.12"
    }
  }, [_vm._v("JBL")])]), _vm._v(" 87 (1968) 245–56.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. “Winged Serpents in Isaiah’s Inaugural Vision,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.12"
    }
  }, [_vm._v("JBL")])]), _vm._v(" 86 (1967) 410–15.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Judge, H. G. “Aaron, Zadok, and Abiathar,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.26"
    }
  }, [_vm._v("JTS")])]), _vm._v(" NS 7 (1956) 70–74.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Kallai-Kleinmann, Z. “The Town Lists of Judah, Simeon, Benjamin, and Dan,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.11"
    }
  }, [_vm._v("VT")])]), _vm._v(" 8 (1958) 134–60.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Kapelrud, A. “How Tradition Failed Moses,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.12"
    }
  }, [_vm._v("JBL")])]), _vm._v(" 76 (1957) 242.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. "), _c('i', [_vm._v("The Ras Shamra Discoveries and the Old Testament")]), _vm._v(". Oxford: Blackwell, 1962.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Kaufmann, Y. “Der Kalendar und der Priester-Kodex,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.11"
    }
  }, [_vm._v("VT")])]), _vm._v(" 4 (1954) 307–13.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. "), _c('i', [_vm._v("The Religion of Israel")]), _vm._v(". Tr. and abridged by M. Greenberg. Chicago: Univ. of Chicago Press, 1960.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Kautzsch, E., ed. "), _c('i', [_vm._v("Gesenius’ Hebrew Grammar")]), _vm._v(". 2nd ed. Tr. A. E. Cowley. Oxford: Clarendon, 1910.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Keil, C. F. "), _c('i', [_vm._v("The Book of Numbers")]), _vm._v(". Biblical Commentary. Tr. J. Martin, et al. Edinburgh: T. & T. Clark, 1869.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Kellermann, D. “"), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("’Āšam")]), _vm._v(" in Ugarit?” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.20"
    }
  }, [_vm._v("ZAW")])]), _vm._v(" 76 (1964) 319–22.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. “Bermerkungen zum Sündopfergesetz in Num. 14:22ff.” In "), _c('i', [_vm._v("Wort und Geschichte: Festschrift für Karl Elliger zum 70. Geburtstag")]), _vm._v(". "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.28"
    }
  }), _vm._v("Ed. H. Gese and H. P. Rüger. Neukirchen: Kevelaer, 1973. Pp. 107–14.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. "), _c('i', [_vm._v("Die Priesterschrift von Numeri 1, 1 bis 10, 10")]), _vm._v(". "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.53"
    }
  }, [_vm._v("BZAW")]), _vm._v(" 120. Berlin: de Gruyter, 1970.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Kennedy, A. R. S. "), _c('i', [_vm._v("Leviticus and Numbers")]), _vm._v(". New Century Bible. London: Caxton, n.d. Pp. 185–391.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Kennett, R. H. “The Origin of the Aaronic Priesthood,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.26"
    }
  }, [_vm._v("JTS")])]), _vm._v(" 6 (1905) 161–86; 7 (1906) 620–24.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Kosmala, H. “Form and Structure in Ancient Hebrew Poetry,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.11"
    }
  }, [_vm._v("VT")])]), _vm._v(" 14 (1964) 423–45.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Kraus, H.-J. “Zur Geschichte des Passah-Massot-Festes im AT,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.56"
    }
  }, [_vm._v("EvT")])]), _vm._v(" 18 (1958) 47–67.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Kselman, J. S. “A note on Numbers 12:6–8,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.11"
    }
  }, [_vm._v("VT")])]), _vm._v(" 26 (1976) 500–504.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Kuschke, A. “Die Lagervorstellung der priesterschriftlichen Erzählung,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.20"
    }
  }, [_vm._v("ZAW")])]), _vm._v(" 22 (1951) 74–105.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Kutsch, E. “Erwägungen zur Geschichte der Passafeier und des Massotfestes,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.45"
    }
  }, [_vm._v("ZTK")])]), _vm._v(" 55 (1958) 1–35.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Lagrange, M. J. “L’Itinéraire des Israélites,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.24"
    }
  }, [_vm._v("RB")])]), _vm._v(" 9 (1900) 63–86.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Latley, C. “Vicarious Solidarity in the Old Testament,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.11"
    }
  }, [_vm._v("VT")])]), _vm._v(" 1 (1951) 267–74.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Laughlin, J. C. H. “The Strange Fire of Nadab and Abihu,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.12"
    }
  }, [_vm._v("JBL")])]), _vm._v(" 95 (1976) 559–65.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("LaVerdiere, E. A. “Balaam Son of Peor,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.59"
    }
  }, [_vm._v("TBT")])]), _vm._v(" 89 (1977) 1157–65.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Lehmann, M. R. “Biblical Oaths,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.20"
    }
  }, [_vm._v("ZAW")])]), _vm._v(" 81 (1969) 74–92.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Lehming, S. “Versuch zu Num. 16,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.20"
    }
  }, [_vm._v("ZAW")])]), _vm._v(" 74 (1962) 291–321.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Leiman, S. Z. “The Inverted "), _c('i', [_vm._v("Nuns")]), _vm._v(" at Num 10:35–36 and the Book of Eldad and Medad,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.12"
    }
  }, [_vm._v("JBL")])]), _vm._v(" 93 (1974) 348–55.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Lemaire, A. “Le ‘Pays de Hépher’ et les ‘Files de Zelophehad’ à la lumière des ostraca de Samarie,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.60"
    }
  }, [_vm._v("Sem")])]), _vm._v(" 22 (1972) 13–20.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Levine, B. “The Descriptive Tabernacle Texts of the Pentateuch,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.16"
    }
  }, [_vm._v("JAOS")])]), _vm._v(" 85 (1965) 307–18.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. "), _c('i', [_vm._v("In the Presence of the Lord: A Study of Cult and Some Cultic Terms in Ancient Israel")]), _vm._v(". "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.61"
    }
  }, [_vm._v("SJLA")]), _vm._v(" 5. Leiden: Brill, 1974.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. “More on the Inverted "), _c('i', [_vm._v("Nuns")]), _vm._v(" of Num 10:35–36,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.12"
    }
  }, [_vm._v("JBL")])]), _vm._v(" 95 (1976) 122–24.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. The Plaster Inscriptions from "), _c('i', [_vm._v("Deir")]), _vm._v(" "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("‘Allā")]), _vm._v(": General Interpretation.” In "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.134"
    }
  }, [_vm._v("Proceedings, 1989")])]), _vm._v(". Pp. 58–72.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Liebreich L. J. “The Songs of Ascents and the Priestly Blessing,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.12"
    }
  }, [_vm._v("JBL")])]), _vm._v(" 74 (1955) 33–36.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Lindblom, J. “Lot-casting in the Old Testament,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.11"
    }
  }, [_vm._v("VT")])]), _vm._v(" 12 (1962) 164–78.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_c('span', {
    staticClass: "lang"
  }, [_vm._v("Lipiński")]), _vm._v(", E. “"), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("b’ḥryt hymym")]), _vm._v(" dans les textes préexiliques,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.11"
    }
  }, [_vm._v("VT")])]), _vm._v(" 20 (1970) 445–50.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. “"), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("’Ūrîm")]), _vm._v(" and "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("Tummîm")]), _vm._v(",” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.11"
    }
  }, [_vm._v("VT")])]), _vm._v(" 20 (1970) 495–96.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.29"
    }
  }), _vm._v("Liver, J. “Korah, Dathan, and Abiram.” In "), _c('i', [_vm._v("Studies in the Bible")]), _vm._v(". "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.62"
    }
  }, [_vm._v("ScrHier")]), _vm._v(" 8. Ed. C. Rabin. Jerusalem: Magnes, 1961. Pp. 189–217.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Lock, W. “Balaam,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.26"
    }
  }, [_vm._v("JTS")])]), _vm._v(" 2 (1901) 161–73.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Loewe, H. “Numbers 22:6,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.36"
    }
  }, [_vm._v("ExpTim")])]), _vm._v(" 26 (1914–15) 378.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Loewenstamm, S. E. “The Death of Moses,” "), _c('i', [_vm._v("Tarbiz")]), _vm._v(" 27 (1957–58) 142–57.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Lohfink, N. “Die Ursünden in der priesterlichen Geschichtserzählung.” In "), _c('i', [_vm._v("Die Zeit Jesu")]), _vm._v(". H. Schlier Festschrift. Ed. G. Bornkamm and K. Rahner. Freiburg: Herder, 1970. Pp. 38–57.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Löhr, M. “Bileam, Num. 22:2–24:25,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.49"
    }
  }, [_vm._v("AfO")])]), _vm._v(" 4 (1927) 85–89.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Long, B. O. “The Effect of Divination upon Israelite Literature,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.12"
    }
  }, [_vm._v("JBL")])]), _vm._v(" 92 (1973) 489–97.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. "), _c('i', [_vm._v("The Problem of Etiological Narrative in the Old Testament")]), _vm._v(". "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.53"
    }
  }, [_vm._v("BZAW")]), _vm._v(" 108. Berlin: Töpelmann, 1968.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Loretz, O. “Die Herausführungsformel in Num. 23:22 und 24:8,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.63"
    }
  }, [_vm._v("UF")])]), _vm._v(" 7 (1975) 571–72.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Lucas, A. “The Number of Israelites at the Time of the Exodus,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.25"
    }
  }, [_vm._v("PEQ")])]), _vm._v(" 76 (1944) 164–68.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("McCarthy, D. J. “An Installation Genre?” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.12"
    }
  }, [_vm._v("JBL")])]), _vm._v(" 90 (1971) 31–41.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. “The Symbolism of Blood and Sacrifice,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.12"
    }
  }, [_vm._v("JBL")])]), _vm._v(" 88 (1969) 166–76.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. “Further Notes on the Symbolism of Blood and Sacrifice,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.12"
    }
  }, [_vm._v("JBL")])]), _vm._v(" 92 (1973) 205–10.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("McEvenue, S. E. "), _c('i', [_vm._v("The Narrative Style of the Priestly Writer")]), _vm._v(". "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.38"
    }
  }, [_vm._v("AnBib")]), _vm._v(" 50. Rome: Pontifical Biblical Institute, 1971.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Mackay, C. “The North Boundary of Palestine,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.26"
    }
  }, [_vm._v("JTS")])]), _vm._v(" 35 (1934) 22–40.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("McKeating, H. “The development of the law on homicide in Ancient Israel,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.11"
    }
  }, [_vm._v("VT")])]), _vm._v(" 25 (1975) 46–68.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Mackensen, R. S. “The Present Form of the Balaam Stories.” In "), _c('i', [_vm._v("The MacDonald Presentation Volume")]), _vm._v(". Princeton: Books for Libraries Press, 1933.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("McNeile, A. H. "), _c('i', [_vm._v("The Book of Numbers in the Revised Version")]), _vm._v(". Cambridge Bible for Schools and Colleges. Cambridge: Cambridge Univ. Press, 1911.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("MacRae, G. W. “The Meaning and Evolution of the Feast of Tabernacles,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.17"
    }
  }, [_vm._v("CBQ")])]), _vm._v(" 22 (1960) 251–76.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Maier, J. “Urim und Tummim. Recht und Bund in der Spannung zwischen Königtum und Priestertum im alten Israel,” "), _c('i', [_vm._v("Kairos")]), _vm._v(" NF 11 (1969) 22–38.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Malina, B. J. "), _c('i', [_vm._v("The Palestinian Manna Tradition")]), _vm._v(". Leiden: Brill, 1968.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Mann, T. W. “Theological Reflections on the Denial of Moses,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.12"
    }
  }, [_vm._v("JBL")])]), _vm._v(" 99 (1979) 481–94.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Margaliot, M. “The Transgression of (Moses and) Aaron at Mey Merivah,” "), _c('i', [_vm._v("Beth Mikra")]), _vm._v(" 58 (1974) 375–400, 456.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.30"
    }
  }), _vm._v("Marsh, J. “Exegesis of the Book of Numbers.” In "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.64"
    }
  }, [_vm._v("IB")])]), _vm._v(", 2. New York: Abingdon, 1953. Pp. 137–308.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Martin-Achard, R. "), _c('i', [_vm._v("Essai biblique sur les fêtes d’Israël")]), _vm._v(". Geneva: Labor et Fides, 1974.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Mauchline, J. “The Balaam-Balak Songs and Saga.” In "), _c('i', [_vm._v("Studie Semitica et Orientalia. Vol. 2. Presentation volume to William Barron Stevenson")]), _vm._v(". Ed. J. C. Mullo-Weir. Glasgow: Glasgow Univ. Oriental Society, 1945.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. “Gilead and Gilgal: Some Reflections on the Israelite Occupation of Palestine,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.11"
    }
  }, [_vm._v("VT")])]), _vm._v(" 6 (1956) 19–33.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("May, H. G. “The Relation of the Passover to the Feast of Unleavened Cakes,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.12"
    }
  }, [_vm._v("JBL")])]), _vm._v(" 55 (1936) 65–82.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Mays, J. L. "), _c('i', [_vm._v("The Book of Leviticus, the Book of Numbers")]), _vm._v(". Layman’s Bible Commentary. Richmond: John Knox, 1963.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Mazar, B. “The Cities of the Priests and Levites.” In "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.46"
    }
  }, [_vm._v("VTSup")]), _vm._v(" 7. Leiden: Brill. Pp. 193–205.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. “The Sanctuary of Arad and the Family of Hobab the Kenite,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.33"
    }
  }, [_vm._v("JNES")])]), _vm._v(" 24 (1965) 297–303.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Meek, T. J. “Aaronites and Zadokites,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.65"
    }
  }, [_vm._v("AJSL")])]), _vm._v(" 45 (1929) 149–66.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. “Moses and Levites,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.65"
    }
  }, [_vm._v("AJSL")])]), _vm._v(" 56 (1939) 113–20.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. “Some Emendations in the Old Testament,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.12"
    }
  }, [_vm._v("JBL")])]), _vm._v(" 48 (1929) 167–68.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Mendenhall, G. E. “The Census Lists of Numbers 1 and 26,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.12"
    }
  }, [_vm._v("JBL")])]), _vm._v(" 77 (1959) 52–66.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. “ ‘Change and Decay in All Around I See’: Conquest, Covenant, and "), _c('i', [_vm._v("The Tenth Generation")]), _vm._v(",” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.14"
    }
  }, [_vm._v("BA")])]), _vm._v(" 39 (1976) 152–57.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. “The Hebrew Conquest of Palestine,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.14"
    }
  }, [_vm._v("BA")])]), _vm._v(" 25 (1962) 66–87.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. "), _c('i', [_vm._v("The Tenth Generation")]), _vm._v(". Baltimore: Johns Hopkins Univ. Press, 1973.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Meshel, Z., and C. Meyers. “The Name of God in the Wilderness of Zin,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.14"
    }
  }, [_vm._v("BA")])]), _vm._v(" 39 (1976) 6–10, 148–51.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Meyers, C. L. "), _c('i', [_vm._v("The Tabernacle Menorah: A Synthetic Study of a Symbol from the Biblical Cult")]), _vm._v(". "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.66"
    }
  }, [_vm._v("AASOR")]), _vm._v(" 2. Missoula, Mont.: Scholars Press, 1976.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Milgrom, J. “Akkadian Confirmation of the Meaning of the Term "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("tĕrûmâ")]), _vm._v(",” "), _c('i', [_vm._v("Tarbiz")]), _vm._v(" 44 (1974/75) 189. Repr. in "), _c('i', [_vm._v("Studies in Cultic Theology and Terminology")]), _vm._v(". Pp. 171–72.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. “The Alleged Wave-offering in Israel and the Ancient Near East,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.67"
    }
  }, [_vm._v("IEJ")])]), _vm._v(" 22 (1972) 33–38. Repr. in "), _c('i', [_vm._v("Studies in Cultic Theology and Terminology")]), _vm._v(". Pp. 133–38.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. “The Biblical Diet Laws as an Ethical System,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.32"
    }
  }, [_vm._v("Int")])]), _vm._v(" 17 (1963) 288–301. Repr. in "), _c('i', [_vm._v("Studies in Cultic Theology and Terminology")]), _vm._v(". Pp. 104–18.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. “Concerning Jeremiah’s Repudiation of Sacrifice,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.20"
    }
  }, [_vm._v("ZAW")])]), _vm._v(" 89 "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.31"
    }
  }), _vm._v("(1977) 274–75. Repr. in "), _c('i', [_vm._v("Studies in Cultic Theology and Terminology")]), _vm._v(". Pp. 119–21.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. Cult and Conscience: "), _c('i', [_vm._v("The")]), _vm._v(" asham "), _c('i', [_vm._v("and the Priestly Doctrine of Repentance")]), _vm._v(". "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.61"
    }
  }, [_vm._v("SJLA")]), _vm._v(" 18. Leiden: Brill, 1976.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. “The Cultic "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("Š")]), _c('sup', {
    staticClass: "i"
  }, [_vm._v("e")]), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("gāgāh")]), _vm._v(" and Its Influence in Psalms and Job,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.68"
    }
  }, [_vm._v("JQR")])]), _vm._v(" 58 (1967) 115–25. Repr. in "), _c('i', [_vm._v("Studies in Cultic Theology and Terminology. Pp. 122–32")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. “"), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("Šattĕnûpâ")]), _vm._v(".” In "), _c('i', [_vm._v("Zer Li’ gevurot")]), _vm._v(". Festschrift for Z. Shazar. Ed. B. Z. Luria. Jerusalem: Kiryat Sepher, 1972. Pp. 93–110. Repr. in "), _c('i', [_vm._v("Studies in Cultic Theology and Terminology")]), _vm._v(". Pp. 139–58.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. “Israel’s Sanctuary: The Priestly ‘Picture of Dorian Gray’,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.24"
    }
  }, [_vm._v("RB")])]), _vm._v(" 83 (1976) 390–99. Repr. in "), _c('i', [_vm._v("Studies in Cultic Theology and Terminology")]), _vm._v(". Pp. 75f–84.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. "), _c('i', [_vm._v("The JPS Torah Commentary: Numbers Bemidbar")]), _vm._v(". Philadelphia/New York: The Jewish Publication Society, 5750/1990.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. “The Literary Structure of Numbers 8:5–22 and the Levitic kippûr.” In "), _c('i', [_vm._v("Perspectives on Language and Text: Essays and Poems in Honor of Francis I. Andersen’s Sixtieth Birthday July 28, 1985")]), _vm._v(". Ed. E. Conrad and E. Newing. Winona Lake, Ind.: Eisenbrauns, 1987. Pp. 205–9.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. “The Paradox of the Red Cow (Num. xix),” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.11"
    }
  }, [_vm._v("VT")])]), _vm._v(" 31 (1981) 62–72. Repr. in "), _c('i', [_vm._v("Studies in Cultic Theology and Terminology")]), _vm._v(". Pp. 85–95.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. “The Priestly Doctrine of Repentance,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.24"
    }
  }, [_vm._v("RB")])]), _vm._v(" 82 (1975) 186–205. Repr. in "), _c('i', [_vm._v("Studies in Cultic Theology and Terminology")]), _vm._v(". Pp. 47–66.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. “Priestly Terminology and the Political and Social Structure of Pre-Monarchic Israel,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.68"
    }
  }, [_vm._v("JQR")])]), _vm._v(" 69 (1978) 65–81. Repr. in "), _c('i', [_vm._v("Studies in Cultic Theology and Terminology")]), _vm._v(". Pp. 1–17.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. “A Prolegomenon to Lev 17:11,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.12"
    }
  }, [_vm._v("JBL")])]), _vm._v(" 90 (1971) 149–56. Repr. in "), _c('i', [_vm._v("Studies in Cultic Theology and Terminology")]), _vm._v(". Pp. 96–103.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. “The "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("Šôq hattĕrûmâ")]), _vm._v(": A Chapter in Cultic History,” "), _c('i', [_vm._v("Tarbiz")]), _vm._v(" 42 (1972–73) 1–14. Repr. in "), _c('i', [_vm._v("Studies in Cultic Theology and Terminology")]), _vm._v(". Pp. 159–70.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. “Sin-offering or Purification-offering?” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.11"
    }
  }, [_vm._v("VT")])]), _vm._v(" 21 (1971) 237–39. Repr. in "), _c('i', [_vm._v("Studies in Cultic Theology and Terminology")]), _vm._v(". Pp. 67–69.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. "), _c('i', [_vm._v("Studies in Cultic Theology and Terminology")]), _vm._v(". "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.61"
    }
  }, [_vm._v("SJLA")]), _vm._v(" 36. Leiden: Brill, 1983.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. "), _c('i', [_vm._v("Studies in Levitical Terminology")]), _vm._v(". Vol. I. University of California Publications, Near Eastern Studies 14. Berkeley: Univ. of California Press, 1970.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. “Two Kinds of "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("ḥaṭṭā’t")]), _vm._v(",” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.11"
    }
  }, [_vm._v("VT")])]), _vm._v(" 26 (1976) 333–37. Repr. in "), _c('i', [_vm._v("Studies in Cultic Theology and Terminology")]), _vm._v(". Pp. 70–74.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Miller, P. D. “The Blessing of God: An Interpretation of Numbers 6:22–27,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.32"
    }
  }, [_vm._v("Int")])]), _vm._v(" 29 (1975) 240–51.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.32"
    }
  }), _vm._v("Mitchell, T. C. “The meaning of the noun "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("ḥtn")]), _vm._v(" in the Old Testament,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.11"
    }
  }, [_vm._v("VT")])]), _vm._v(" 19 (1969) 93–112.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Mittmann, S. “Num. 20:14–21—eine radaktionelle Kompilation.” In "), _c('i', [_vm._v("Wort und Geschichte: Festschrift für Karl Elliger zum 70. Geburtstag")]), _vm._v(". Ed. H. Gese and H. P. Rüger. Neukirchen-Vluyn: Neukirchener, 1973.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Möhlenbrink, K. “Die levitischen überlieferungen des Alten Testament,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.20"
    }
  }, [_vm._v("ZAW")])]), _vm._v(" 52 (1934) 184–231.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Moore, M. "), _c('i', [_vm._v("The Balaam Traditions: Their Character and Development")]), _vm._v(". "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.35"
    }
  }, [_vm._v("SBLDS")]), _vm._v(" 113. Atlanta: Scholars Press, 1990.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Morgan, D. F. “The So-Called Cultic Calendars in the Pentateuch (Ex. 23:10–19, 34:18–26, Lev. 23, Nu. 28–29, Deut. 16:1–17). A Morphological and Typological Study.” Ph.D. diss., Claremont School of Theology, 1974.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Morgenstern, J. "), _c('i', [_vm._v("The Ark, the Ephod, and the “Tent of Meeting.”")]), _vm._v(" Cincinnati: Hebrew Union College, 1945.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. “A Chapter in the History of the High Priesthood,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.65"
    }
  }, [_vm._v("AJSL")])]), _vm._v(" 55 (1938) 1–24, 360–77.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. “The Three Calendars of Ancient Israel,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.23"
    }
  }, [_vm._v("HUCA")])]), _vm._v(" 1 (1924) 13–78; 3 (1926) 77–107; 10 (1935) 1–148.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. “Trial by Ordeal among the Semites in Ancient Israel,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.23"
    }
  }, [_vm._v("HUCA")]), _vm._v(" Jubilee Volume")]), _vm._v(" (1925) 113–43.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. “Two Ancient Israelite Agricultural Festivals,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.68"
    }
  }, [_vm._v("JQR")])]), _vm._v(" 8 (1917–18) 39–50.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Mowinckel, S. "), _c('i', [_vm._v("Tetrateuch—Pentateuch—Hexateuch. Die Berichte über die Landnahme in den drei altisraelitischen Geschichtswerken")]), _vm._v(". "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.53"
    }
  }, [_vm._v("BZAW")]), _vm._v(" 90. Berlin: Töpelmann, 1964.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. “Der Ursprung der Bileamsage,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.20"
    }
  }, [_vm._v("ZAW")])]), _vm._v(" 48 (1930) 233–71.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Müller, H.-P. “Die aramäische Inschrift von "), _c('i', [_vm._v("Deir")]), _vm._v(" "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("‘Allā")]), _vm._v(" und die älteren Bileamsprüche.” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.20"
    }
  }, [_vm._v("ZAW")])]), _vm._v(" 94 (1982) 214–44.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. “Einige alttestamentliche Probleme zur aramäische Inschrift von "), _c('i', [_vm._v("Deir")]), _vm._v(" "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("‘Allā")]), _vm._v(".” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.48"
    }
  }, [_vm._v("ZDPV")])]), _vm._v(" 94 (1978) 56–67.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Mullen, E. T. "), _c('i', [_vm._v("The Assembly of the Gods: The Divine Council in Canaanite and Early Hebrew Literature")]), _vm._v(". "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.51"
    }
  }, [_vm._v("HSM")]), _vm._v(" 24. Chico, Calif.: Scholars Press, 1980.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Murtonen, A. “The Use and Meaning of the Words "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("L")]), _c('sup', {
    staticClass: "i"
  }, [_vm._v("e")]), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("ḇarek")]), _vm._v(" and "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("B")]), _c('sup', {
    staticClass: "i"
  }, [_vm._v("e")]), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("rakah")]), _vm._v(" in the Old Testament,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.11"
    }
  }, [_vm._v("VT")])]), _vm._v(" 9 (1959) 158–77.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Nestlé, E. “Num. 23:19,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.20"
    }
  }, [_vm._v("ZAW")])]), _vm._v(" 28 (1908) 228–29.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Neusner, J. "), _c('i', [_vm._v("The Idea of Purity in Ancient Israel")]), _vm._v(". Leiden: Brill, 1973.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Newing, E. G. “The Rhetoric of Altercation in Numbers 14.” In "), _c('i', [_vm._v("Perspectives on Language and Text: Essays and Poems in Honor of Francis I. Andersen’s Sixtieth Birthday July 28, 1985")]), _vm._v(". Ed. E. Conrad and E. Newing. Winona Lake, Ind.: Eisenbrauns, 1987. Pp. 211–28.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.33"
    }
  }), _vm._v("Nielsen, E. “The Levites in Ancient Israel,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.69"
    }
  }, [_vm._v("ASTI")])]), _vm._v(" 3 (1964) 16–27.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Noordtzij, A. "), _c('i', [_vm._v("Numbers")]), _vm._v(". Bible Student’s Commentary. Tr. E. van der Maas. Grand Rapids: Zondervan, 1983.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("North, F. “Aaron’s Rise in Prestige,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.20"
    }
  }, [_vm._v("ZAW")])]), _vm._v(" 66 (1954) 191–99.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Noth, M. "), _c('i', [_vm._v("A History of Pentateuchal Traditions")]), _vm._v(". Tr. B. W. Anderson. Englwood Cliffs, N.J.: Prentice-Hall, 1981.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. “Israelitische Stämme zwischen Ammon und Moab,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.20"
    }
  }, [_vm._v("ZAW")])]), _vm._v(" 60 (1944) 11–57.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. "), _c('i', [_vm._v("Die Israelititischen Personennamen im Rahmen der Gemeinsemitischen Namengebung")]), _vm._v(". "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.27"
    }
  }, [_vm._v("BWANT")]), _vm._v(" 3/10. Stuttgart: Kohlhammer, 1928.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. "), _c('i', [_vm._v("The Laws in the Pentateuch and Other Essays")]), _vm._v(". Tr. D. R. Ap-Thomas. Philadelphia: Fortress, 1967.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. “Num. 21 als Glied der ‘Hexateuch’ Erzählung,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.20"
    }
  }, [_vm._v("ZAW")])]), _vm._v(" 58 (1940–41) 161–89.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. "), _c('i', [_vm._v("Numbers: A Commentary")]), _vm._v(". Tr. J. D. Martin. "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.43"
    }
  }, [_vm._v("OTL")]), _vm._v(". Philadelphia: Westminster, 1968.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. "), _c('i', [_vm._v("Das System der zwölf Stämme Israels")]), _vm._v(". "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.27"
    }
  }, [_vm._v("BWANT")]), _vm._v(" 4/1. Stuttgart: Kohlhammer, 1930.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. “Der Wallfahrtsweg zum Sinai,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.70"
    }
  }, [_vm._v("PJ")])]), _vm._v(" 36 (1940) 5–28.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Nyberg, H. S. “Korahs Upror (Num. 16f.),” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.136"
    }
  }, [_vm._v("SEÅ")])]), _vm._v(" 11 (1946) 214–36.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Olávarri, E. “Sondages à “Arô‘er sur l’Arnon,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.24"
    }
  }, [_vm._v("RB")])]), _vm._v(" 72 (1965) 77–94; 76 (1969) 230–59.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Olson, D. T. "), _c('i', [_vm._v("The Death of the Old and the Birth of the New: The Framework of the Book of Numbers and the Pentateuch")]), _vm._v(". "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.71"
    }
  }, [_vm._v("BJS")]), _vm._v(" 71. Chico, Calif.: Scholars Press, 1985.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Orlinsky, H. M. “Numbers XXVIII 9, 12, 13,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.11"
    }
  }, [_vm._v("VT")])]), _vm._v(" 20 (1970) 500.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. “"), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("Rābas")]), _vm._v(" for "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("Šākab")]), _vm._v(" in Num. 24:9,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.68"
    }
  }, [_vm._v("JQR")])]), _vm._v(" 35 (1944–45) 173–77.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Pákosdy, L. M. von. “Theologische Redaktionsarbeit in der BileamPerikope.” In "), _c('i', [_vm._v("Von Ugarit nach Qumran")]), _vm._v(". Festschrift for O. Eissfeldt. Ed. J. Hempel and L. Rost. "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.53"
    }
  }, [_vm._v("BZAW")]), _vm._v(" 77. Berlin: Töpelmann, 1958. Pp. 161–76.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Paradise, J. “A Daughter and Her Father’s Property at Nuzi,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.72"
    }
  }, [_vm._v("JCS")])]), _vm._v(" 32 (1980) 189–207.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Parker, I. “The Way of God and the Way of Balaam,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.36"
    }
  }, [_vm._v("ExpTim")])]), _vm._v(" 17 (1905) 45.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Parker, S. B. “Possession trance and prophecy in pre-exilic Israel,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.11"
    }
  }, [_vm._v("VT")])]), _vm._v(" 28 (1978) 271–85.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Paterson, J. A. "), _c('i', [_vm._v("Book of Numbers")]), _vm._v(". "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.73"
    }
  }, [_vm._v("SBOT")]), _vm._v(". Leipzig: Hinrichs, 1900.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Patrick, D. "), _c('i', [_vm._v("Old Testament Law")]), _vm._v(". Atlanta: John Knox, 1985.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Pedersen, J. "), _c('i', [_vm._v("Israel: Its Life and Culture")]), _vm._v(". 4 vols. repr. in 2. London: Oxford, 1926–40.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Perles, F. “Zu Numeri 24:23,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.20"
    }
  }, [_vm._v("ZAW")])]), _vm._v(" 29 (1909) 73.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.34"
    }
  }), _vm._v("Péter, R. “L’imposition des mains dans l’Ancien Testament,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.11"
    }
  }, [_vm._v("VT")])]), _vm._v(" 27 (1977) 48–55.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Petrie, W. M. F. "), _c('i', [_vm._v("Egypt and Israel")]), _vm._v(". New York: Macmillan, 1923.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. "), _c('i', [_vm._v("Researches in Sinai")]), _vm._v(". London: Murray, 1906.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Phillips, A. “The Case of the Woodgatherer Reconsidered,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.11"
    }
  }, [_vm._v("VT")])]), _vm._v(" 19 (1969) 125–28.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Porter, J. R. “The Role of Kadesh-barnea in the Narrative of the Exodus,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.26"
    }
  }, [_vm._v("JTS")])]), _vm._v(" 44 (1943) 139–43.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Press, R. “Das Ordal im alten Israel,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.20"
    }
  }, [_vm._v("ZAW")])]), _vm._v(" 51 (1933) 121–40, 227–55.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Rabe, V. W. “The Origins of Prophecy,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.42"
    }
  }, [_vm._v("BASOR")])]), _vm._v(" 221 (1976) 125–28.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Rackman, E. “Jewish Philosophy of Property,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.68"
    }
  }, [_vm._v("JQR")])]), _vm._v(" 67 (1976–77) 65–89.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Rad, G. von. "), _c('i', [_vm._v("Old Testament Theology")]), _vm._v(". Trans. D. Stalker. 2 vols. New York: Harper & Row, 1962, 1965.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. “The Story about Balaam.” In "), _c('i', [_vm._v("God at Work in Israel")]), _vm._v(". Tr. J. Marks. Nashville: Abingdon, 1980.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Rainey, A. F. “The Order of Sacrifices in Old Testament Ritual Texts,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.74"
    }
  }, [_vm._v("Bib")])]), _vm._v(" 51 (1970) 485–98.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Ramsay, G. W. “Speech Forms in Hebrew Law and Prophetic Oracles,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.12"
    }
  }, [_vm._v("JBL")])]), _vm._v(" 96 (1977) 45–58.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Reif, S. C. “A note on a neglected connotation of "), _c('i', [_vm._v("ntn")]), _vm._v(",” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.11"
    }
  }, [_vm._v("VT")])]), _vm._v(" 20 (1970) 114–16.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. “What Enraged Phinehas?” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.12"
    }
  }, [_vm._v("JBL")])]), _vm._v(" 90 (1971) 100–106.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Rendtorff, R. "), _c('i', [_vm._v("Die Gesetze in der Priesterschrift: Eine Gattungsgeschichtlichen Untersuchung")]), _vm._v(". Göttingen: Vandenhoeck & Ruprecht, 1954.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. “Traditio-historical Method and the Documentary Hypothesis,” "), _c('i', [_vm._v("Proceedings of the World Congress of Jewish Studies")]), _vm._v(" 5 (1969) 5–11.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. "), _c('i', [_vm._v("The Problem of the Process of Transmission in the Pentateuch")]), _vm._v(". Tr. J. Scullion. "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.31"
    }
  }, [_vm._v("JSOTSup")]), _vm._v(" 89. Sheffield: "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.21"
    }
  }, [_vm._v("JSOT")]), _vm._v(" Press, 1990. (Orig. "), _c('i', [_vm._v("Das überlieferungsgeschichtliche Problem des Pentateuch")]), _vm._v(". "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.53"
    }
  }, [_vm._v("BZAW")]), _vm._v(" 147. Berlin: de Gruyter, 1977.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. “The Yahwist as Theologian: Dilemma of Pentateuchal Criticism,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.21"
    }
  }, [_vm._v("JSOT")])]), _vm._v(" 3 (1977) 2–45.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. “Zur Lage von Jaser,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.48"
    }
  }, [_vm._v("ZDPV")])]), _vm._v(" 76 (1960) 124–35.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Richter, G. “Die Einheitlichkeit der Geschichte von der Rotte Korah,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.20"
    }
  }, [_vm._v("ZAW")])]), _vm._v(" 39 (1921) 123–37.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Riggans, W. "), _c('i', [_vm._v("Numbers")]), _vm._v(". Daily Study Bible. Philadelphia: Westminster, 1983.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Roach, C. C. “The Camp in the Wilderness: A Sermon on Numbers 2:2,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.32"
    }
  }, [_vm._v("Int")])]), _vm._v(" 13 (1959) 49–54.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Robertson, E. “The "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("’ūrīm")]), _vm._v(" and "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("ṯummīm")]), _vm._v("; what were they?” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.11"
    }
  }, [_vm._v("VT")])]), _vm._v(" 14 (1964) 67–74.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.35"
    }
  }), _vm._v("Robinson, G. “The Prohibition of Strange Fire in Ancient Israel,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.11"
    }
  }, [_vm._v("VT")])]), _vm._v(" 28 (1978) 301–17.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Rofé, A. "), _c('i', [_vm._v("The Book of Balaam")]), _vm._v(" (Hebrew). Jerusalem: Simor, 1979.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Rost, L. “Fragen um Bileam.” "), _c('i', [_vm._v("Beiträge zur alttestamentlichen Theologie: Festschrift für Walther Zimmerli zum 70. Geburtstag")]), _vm._v(". Ed. H. Donner, et al. Göttingen: Vandenhoeck & Ruprecht, 1977. Pp. 377–87.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. “Zu den Festopfervorschriften von Numeri 28 u. 29,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.75"
    }
  }, [_vm._v("TLZ")])]), _vm._v(" 83 (1958) 329–34.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Rouillard, H. “L’ânesse de Balaam,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.24"
    }
  }, [_vm._v("RB")])]), _vm._v(" 87 (1980) 5–36.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Rowley, H. H. “Zadok and Nehushtan,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.12"
    }
  }, [_vm._v("JBL")])]), _vm._v(" 58 (1939) 113–41.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Ruppert, L. “Das Motiv der Versuchung durch Gott in vordeuteronomistischer Tradition,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.11"
    }
  }, [_vm._v("VT")])]), _vm._v(" 22 (1972) 55–63.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Sabourin, L. “The Biblical Cloud: Terminology and Traditions,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.10"
    }
  }, [_vm._v("BTB")])]), _vm._v(" 4 (1974) 290–311.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Sakenfeld, K. D. “The Problem of Divine Forgiveness in Num. 14,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.17"
    }
  }, [_vm._v("CBQ")])]), _vm._v(" 37 (1975) 317–30.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Sasson, J. M. “A ‘Genealogical Convention’ in Biblical Chronography?” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.20"
    }
  }, [_vm._v("ZAW")])]), _vm._v(" 90 (1978) 171–85.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. “Nu. 5 and the Waters of Judgment,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.76"
    }
  }, [_vm._v("BZ")])]), _vm._v(" 16 (1972) 249–51.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Saydon, P. P. “Sin-Offering and Trespass-Offering,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.17"
    }
  }, [_vm._v("CBQ")])]), _vm._v(" 8 (1946) 393–98.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("St. Clair, G. “Israel in Camp: A Study,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.26"
    }
  }, [_vm._v("JTS")])]), _vm._v(" 8 (1907) 185–217.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Scharbert, J. “Fluchen und Segnen im Alten Testament,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.74"
    }
  }, [_vm._v("Bib")])]), _vm._v(" 39 (1958) 1–26.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Schedl, C. “Biblische Zahlen unglaubwürdig?” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.77"
    }
  }, [_vm._v("TPQ")])]), _vm._v(" 107 (1959) 58–62.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Schmidt, L. “Die alttestamentliche Bileamüberlieferung,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.76"
    }
  }, [_vm._v("BZ")])]), _vm._v(" 23 (1979) 234–61.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Schmidt, W. “"), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("miškan")]), _vm._v(" als Ausdruck Jerusalemer Kultsprache,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.20"
    }
  }, [_vm._v("ZAW")])]), _vm._v(" 75 (1963) 91–92.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Schottroff, S. "), _c('i', [_vm._v("Der altisraelitische Fluchspruch")]), _vm._v(". "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.78"
    }
  }, [_vm._v("WMANT")]), _vm._v(" 30. Neukirchen: Kreis Moers, 1969.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Schulz, H. "), _c('i', [_vm._v("Leviten im vorstaatlichen Israel und im Mittleren Osten")]), _vm._v(". Munich: Chr. Kaiser, 1987.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. "), _c('i', [_vm._v("Das Todesricht im Alten Testament")]), _vm._v(". "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.53"
    }
  }, [_vm._v("BZAW")]), _vm._v(" 114. Berlin: Töpelmann, 1969.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Schunk, K.-D. "), _c('i', [_vm._v("Benjamin. Untersuchungen zur Entstehung und Geschichte eines israelitischen Stammes")]), _vm._v(". "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.53"
    }
  }, [_vm._v("BZAW")]), _vm._v(" 86. Berlin: Töpelmann, 1963.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. “Ophra, Ephron und Ephraim,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.11"
    }
  }, [_vm._v("VT")])]), _vm._v(" 11 (1961) 188–200.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Seebass, H. “Num. xi, xii und die Hypothese des Jahwisten,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.11"
    }
  }, [_vm._v("VT")])]), _vm._v(" 28 (1978) 214–23.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. “Zu Num. X 33f.,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.11"
    }
  }, [_vm._v("VT")])]), _vm._v(" 14 (1964) 111–13.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.36"
    }
  }), _vm._v("Segal, J. B. “The Hebrew Festivals and the Calendar,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.28"
    }
  }, [_vm._v("JSS")])]), _vm._v(" 6 (1961) 74–94.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. "), _c('i', [_vm._v("The Hebrew Passover")]), _vm._v(". London: SPCK, 1963.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. “Intercalation and the Hebrew Calendar,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.11"
    }
  }, [_vm._v("VT")])]), _vm._v(" 7 (1957) 250–307.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. "), _c('i', [_vm._v("The Pentateuch: Its Composition and Its Authorship and Other Studies")]), _vm._v(". Jerusalem: Magnes, 1967.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. “The Settlement of Manasseh East of the Jordan,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.79"
    }
  }, [_vm._v("PEFQS")])]), _vm._v(" 50 (1918) 124–31.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Sellin, E. O. “Zu Efod und Terafim,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.20"
    }
  }, [_vm._v("ZAW")])]), _vm._v(" 55 (1937) 296–98.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Seybold, K. “Das Herrscherbild des Bileamorakels, Num. 24:15–19,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.76"
    }
  }, [_vm._v("BZ")])]), _vm._v(" 29 (1979) 1–19.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Simons, J. "), _c('i', [_vm._v("Geographical and Topographical Texts of the Old Testament")]), _vm._v(". Leiden: Brill, 1959.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. “Two Connected Problems Relating to the Israelite Settlement in Transjordan,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.25"
    }
  }, [_vm._v("PEQ")])]), _vm._v(" 79 (1947) 27–39, 87–101.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Simpson, C. A. "), _c('i', [_vm._v("The Early Traditions of Israel")]), _vm._v(". Oxford: Blackwell, 1948.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Smick, E. B. “A Study of the Structure of the Third Balaam Oracle (Num. 24:5–9).” In "), _c('i', [_vm._v("The Law and the Prophets: Old Testament Studies in Honor of Oswald T. Allis")]), _vm._v(". Ed. J. Skilton. Nutley, N.J.: Presbyterian & Reformed, 1974.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Smith, W. R. "), _c('i', [_vm._v("The Religion of the Semites")]), _vm._v(". 2nd ed. London: Black, 1907.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Snaith, N. H. “The Daughters of Zelophehad,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.11"
    }
  }, [_vm._v("VT")])]), _vm._v(" 16 (1966) 124–27.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. "), _c('i', [_vm._v("The Hebrew New Year Festival")]), _vm._v(". London: SPCK, 1947.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. "), _c('i', [_vm._v("Leviticus and Numbers")]), _vm._v(". "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.80"
    }
  }, [_vm._v("NCBC")]), _vm._v(". London: Nelson, 1967.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. “A Note on Numbers XVIII 9,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.11"
    }
  }, [_vm._v("VT")])]), _vm._v(" 23 (1973) 373–75.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. “Numbers XXVIII 9, 11, 13,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.11"
    }
  }, [_vm._v("VT")])]), _vm._v(" 19 (1969) 374.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. “Sacrifices in the Old Testament,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.11"
    }
  }, [_vm._v("VT")])]), _vm._v(" 7 (1957) 308–17.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. “The Sin Offering and the Guilt Offering,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.11"
    }
  }, [_vm._v("VT")])]), _vm._v(" 15 (1965) 73–80.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Snijders, L. A. “The Meaning of "), _c('i', [_vm._v("‘zar’")]), _vm._v(" in the Old Testament,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.40"
    }
  }, [_vm._v("OTS")])]), _vm._v(" 10 (1954) 1–154.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Sonsino, R. "), _c('i', [_vm._v("Motive Clauses in Hebrew Law")]), _vm._v(". "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.35"
    }
  }, [_vm._v("SBLDS")]), _vm._v(" 45. Chico, Calif.: Scholars Press, 1980.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Speiser, E. A. “Census and Ritual Expiation in Mari and Israel.” In "), _c('i', [_vm._v("Biblical and Oriental Studies")]), _vm._v(". Ed. J. J. Finkelstein and M. Greenberg. Philadelphia: Univ. of Pennsylvania Press, 1967. Pp. 171–86.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. “Unrecognized Dedication,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.67"
    }
  }, [_vm._v("IEJ")])]), _vm._v(" 13 (1963) 69–73.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Stade, B. “Die Eiferopferthora,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.20"
    }
  }, [_vm._v("ZAW")])]), _vm._v(" 15 (1895) 166–78.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Stephens, F. J. “The Ancient Significance of "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("Ṣiṣith")]), _vm._v(",” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.12"
    }
  }, [_vm._v("JBL")])]), _vm._v(" 50 (1931) 59–71.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Stevenson, W. R. “Hebrew Olah and Zebach Sacrifices.” In "), _c('i', [_vm._v("Festschrift für A. Bertholet")]), _vm._v(". Ed. W. Baumgartner, et al. Tübingen: Mohr, 1950. Pp. 488–97.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Strack, H. L. "), _c('i', [_vm._v("Die Bücher Genesis, Exodus, Leviticus und Numeri")]), _vm._v(". Kurzgefasster "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.37"
    }
  }), _vm._v("Kommentar zu den Heiligen Schriften Alten und Neuen Testamentes sowie zu den Apokryphen. Nordlingen: C. H. Beck, 1894.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Sturdy, J. "), _c('i', [_vm._v("Numbers")]), _vm._v(". Cambridge Bible ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.81"
    }
  }, [_vm._v("NEB")]), _vm._v("). New York: Cambridge Univ. Press, 1976.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Sumner, W. A. “Israel’s encounters with Edom, Moab, Ammon, Sihon, and Og according to the Deuteronomist,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.11"
    }
  }, [_vm._v("VT")])]), _vm._v(" 18 (1968) 216–28.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Sutcliffe, E. F. “De Unitate Litteraria Num. 22,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.74"
    }
  }, [_vm._v("Bib")])]), _vm._v(" 7 (1926) 3–39.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. “A Note on Num. 22,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.74"
    }
  }, [_vm._v("Bib")])]), _vm._v(" 18 (1937) 439–42.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Talmon, S. “Divergencies in Calendar Reckoning in Ephraim and Judah,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.11"
    }
  }, [_vm._v("VT")])]), _vm._v(" 8 (1958) 48–74.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Thiersch, H. “Ependytes und Ephod,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.20"
    }
  }, [_vm._v("ZAW")])]), _vm._v(" 53 (1935) 180–85.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Thomas, D. W. “The Word "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("rōḇaʿ")]), _vm._v(" in Numbers 23:10,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.36"
    }
  }, [_vm._v("ExpTim")])]), _vm._v(" 46 (1934–35) 285.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. “Some Further Remarks on Unusual Ways of Expressing the Superlative in Hebrew,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.11"
    }
  }, [_vm._v("VT")])]), _vm._v(" 18 (1968) 120–24.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Thompson, H. C. “The Significance of the Term "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("’āsham")]), _vm._v(" in the Old Testament,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.82"
    }
  }, [_vm._v("TGUOS")])]), _vm._v(" 14 (1953) 20–26.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Thompson H. O. “The Ammonite Remains at Khirbet al-Hajjar,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.42"
    }
  }, [_vm._v("BASOR")])]), _vm._v(" 227 (1977) 27–34.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Thompson, R. J. "), _c('i', [_vm._v("Moses and the Law in a Century of Criticism Since Graf")]), _vm._v(". Leiden: Brill, 1970.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. "), _c('i', [_vm._v("Penitence and Sacrifice in Early Israel Outside the Levitical Law: An Examination of the Fellowship Theory of Early Israelite Sacrifice")]), _vm._v(". Leiden: Brill, 1963.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Tosato, A. “The Literary Structure of the First Two Poems of Balaam (Num. 23:7–10, 18–24),” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.11"
    }
  }, [_vm._v("VT")])]), _vm._v(" 29 (1979) 98–106.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Tucker, G. M. “Covenant Forms and Contract Forms,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.11"
    }
  }, [_vm._v("VT")])]), _vm._v(" 15 (1965) 487–503.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Tunyogi, A. C. “The Rebellions of Israel,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.12"
    }
  }, [_vm._v("JBL")])]), _vm._v(" 81 (1962) 385–90.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. "), _c('i', [_vm._v("The Rebellions of Israel")]), _vm._v(". Richmond: John Knox, 1969.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Tushingham, A. D. “The Excavations at Dibon (Dhiban) in Moab, the Third Campaign 1952–53,” "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.66"
    }
  }, [_vm._v("AASOR")]), _vm._v(" 40 (1972) 93.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Urie, D. “Officials of the Cult at Ugarit,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.25"
    }
  }, [_vm._v("PEQ")])]), _vm._v(" 80 (1948) 42–47.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Valentin, H. "), _c('i', [_vm._v("Aaron. Eine Studie zur vorpriesterschriftlichen Aaron überlieferung")]), _vm._v(". Göttingen: Vandenhoeck & Ruprecht, 1978.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("van der Kooij. “Book and Script at Deir ‘Alla.” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.134"
    }
  }, [_vm._v("Proceedings, 1989")])]), _vm._v(". Pp. 239–62.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("van der Ploeg, J. “Studies in Hebrew Law,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.17"
    }
  }, [_vm._v("CBQ")])]), _vm._v(" 12 (1950) 248–59, 416–27; 13 (1951) 28–43, 164–71, 296–307.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("van Goudoever, J. "), _c('i', [_vm._v("Biblical Calendars")]), _vm._v(". Leiden: Brill, 1959.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Van Seters, J. “The Conquest of Sihon’s Kingdom: A Literary Examination,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.12"
    }
  }, [_vm._v("JBL")])]), _vm._v(" 91 (1972) 182–97.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.38"
    }
  }), _vm._v("“Once Again: The Conquest of Sihon’s Kingdom,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.12"
    }
  }, [_vm._v("JBL")])]), _vm._v(" 99 (1980) 117–19.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. “Recent Studies on the Pentateuch: A Crisis in Method,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.16"
    }
  }, [_vm._v("JAOS")])]), _vm._v(" 99 (1979) 663–72.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. “The terms ‘Amorite’ and ‘Hittite’,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.11"
    }
  }, [_vm._v("VT")])]), _vm._v(" 22 (1972) 64–81.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Vaulx, J. de. "), _c('i', [_vm._v("Les Nombres")]), _vm._v(". "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.83"
    }
  }, [_vm._v("SB")]), _vm._v(". Paris: J. Gabalda, 1972.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Vaux, R. de. "), _c('i', [_vm._v("Ancient Israel. Its Life and Institutions")]), _vm._v(". Tr. J. McHugh. 2 vols. London: Darton, Longman and Todd; New York: McGraw-Hill, 1961.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. “Ark of the Covenant and Tent of Reunion.” In "), _c('i', [_vm._v("The Bible and the Ancient Near East")]), _vm._v(". Tr. D. McHugh. Garden City, N.Y.: Doubleday, 1971. Pp. 136–51.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. "), _c('i', [_vm._v("The Early History of Israel")]), _vm._v(". Tr. D. Smith. Philadelphia: Westminster, 1978.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. “L’Itinéraire des Israéliens de Cadès aux Plaines de Moab.” In "), _c('i', [_vm._v("Hommages à André Dupont–Sommer")]), _vm._v(". Ed. A. Caquot and M. Philonenko. Paris: Librairie d’Amerique et d’Orient, 1971. Pp. 136–51.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. “Notes d’histoire et de topographie transjordaniennes,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.24"
    }
  }, [_vm._v("RB")])]), _vm._v(" 50 (1941) 16–47.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. “Le Pays de Canaan,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.16"
    }
  }, [_vm._v("JAOS")])]), _vm._v(" 88 (1968) 23–30.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. “Reflections on the Present State of Pentateuchal Criticism.” In "), _c('i', [_vm._v("The Bible and the Ancient Near East")]), _vm._v(". Tr. D. McHugh. Garden City, N.Y.: Doubleday, 1971. Pp. 31–48.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. "), _c('i', [_vm._v("Studies in Old Testament Sacrifice")]), _vm._v(". Tr. J. Bourke and R. Potter. Cardiff: Univ. of Wales Press, 1964.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Vermes, G. “The Story of Balaam: The Scriptural Origin of Haggadah.” In "), _c('i', [_vm._v("Scripture and Tradition in Judaism")]), _vm._v(". Leiden: Brill, 1955. Pp. 127–77.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Vetter, D. "), _c('i', [_vm._v("Seherspruch und Segensschilderung. Ausdruckabsichten und sprachliche Verwirklichungen in den Bileam-Sprüchen von Numeri 23 und 24")]), _vm._v(". Stuttgart: Calwer Verlag, 1975.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Wagner, S. “Die Kundschaftergeschichten im Alten Testament,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.20"
    }
  }, [_vm._v("ZAW")])]), _vm._v(" 76 (1964) 255–69.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. “Offenbarungsphänomenologische Elemente in der Bileam-Geschichte von Num. 22–24,” "), _c('i', [_vm._v("Theologische Versuche")]), _vm._v(" 5 (1975) 11–31.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Walsh, J. T. “From Egypt to Moab: A Source Critical Analysis of the Wilderness Itinerary,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.17"
    }
  }, [_vm._v("CBQ")])]), _vm._v(" 39 (1977) 20–33.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Walters, S. D. “Prophecy in Mari and Israel,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.12"
    }
  }, [_vm._v("JBL")])]), _vm._v(" 89 (1970) 78–81.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Wanke, G. "), _c('i', [_vm._v("Die Zionstheologie der Korachiten")]), _vm._v(". "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.53"
    }
  }, [_vm._v("BZAW")]), _vm._v(" 97. Berlin: Töpelmann, 1966.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Waterman, L. “Some Determining Factors in the Northward Progress of Levi,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.16"
    }
  }, [_vm._v("JAOS")])]), _vm._v(" 57 (1937) 375–80.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.39"
    }
  }), _vm._v("Watson, J. "), _c('i', [_vm._v("Leviticus-Numbers")]), _vm._v(". Expositor’s Bible. New York: Armstrong, 1903.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Wefing, S. “Beobachtungen zum Ritual mit der roten Kuh (Num 19:1–10a),” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.20"
    }
  }, [_vm._v("ZAW")])]), _vm._v(" 93 (1981) 341–64.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Weinberg, J. P. “Das Beit ’Abot im Jh. v.u.Z.,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.11"
    }
  }, [_vm._v("VT")])]), _vm._v(" 23 (1973) 400–414.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Weingreen, J. “The Case of the Daughters of Zelophehad,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.11"
    }
  }, [_vm._v("VT")])]), _vm._v(" 16 (1966) 518–22.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. “The Case of the Woodgatherer (Numbers XV 32–36),” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.11"
    }
  }, [_vm._v("VT")])]), _vm._v(" 16 (1966) 361–64.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Weippert, H. “Das geographische System der Stämme Israels,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.11"
    }
  }, [_vm._v("VT")])]), _vm._v(" 23 (1973) 76–89.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Weippert, M. "), _c('i', [_vm._v("The Settlement of the Israelite Tribes in Palestine")]), _vm._v(". "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.84"
    }
  }, [_vm._v("SBT")]), _vm._v(" 2/21. London: SCM, 1971.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. “The Balaam Text from "), _c('i', [_vm._v("Deir")]), _vm._v(" "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("‘Allā")]), _vm._v(" and the Study of the Old Testament.” In "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.134"
    }
  }, [_vm._v("Proceedings, 1989")])]), _vm._v(". Pp. 151–84.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Weisman, Z. “The Biblical Nazirite, Its Types and Roots,” "), _c('i', [_vm._v("Tarbiz")]), _vm._v(" 36 (1967) 207–20.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Wellhausen, J. "), _c('i', [_vm._v("Prolegomena to the History of Ancient Israel")]), _vm._v(". Tr. J. S. Black and A. Menzies. Gloucester, Mass.: Peter Smith, 1973.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Wenham, G. J. "), _c('i', [_vm._v("Numbers: An Introduction and Commentary")]), _vm._v(". "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.85"
    }
  }, [_vm._v("TOTC")]), _vm._v(". Downers Grove: Inter-Varsity, 1981.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Wenham, J. W. “Large Numbers in the Old Testament,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.39"
    }
  }, [_vm._v("TynBul")])]), _vm._v(" 18 (1967) 19–53.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Westphal, G. “Aaron und die Aaroniden,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.20"
    }
  }, [_vm._v("ZAW")])]), _vm._v(" 26 (1906) 201–30.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Wharton, J. A. “The Command to Bless: An Exposition of Numbers 22:41–23:25,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.32"
    }
  }, [_vm._v("Int")])]), _vm._v(" 13 (1959) 37–48.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Whybray, R. N. "), _c('i', [_vm._v("The Making of the Pentateuch: A Methodological Study")]), _vm._v(". "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.31"
    }
  }, [_vm._v("JSOTSup")]), _vm._v(" 53. Sheffield: "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.21"
    }
  }, [_vm._v("JSOT")]), _vm._v(" Press, 1985.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Williams, R. J. "), _c('i', [_vm._v("Hebrew Syntax")]), _vm._v(". 2nd ed. Toronto: Univ. of Toronto Press, 1976.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Wilson, R. R. “Between ‘Azel’ and ‘Azel,’ Interpreting the Biblical Genealogies,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.14"
    }
  }, [_vm._v("BA")])]), _vm._v(" 42 (1979) 11–22.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. "), _c('i', [_vm._v("Genealogy and History in the Biblical World")]), _vm._v(". New Haven: Yale Univ. Press, 1977.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. “Early Israelite Prophecy,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.32"
    }
  }, [_vm._v("Int")])]), _vm._v(" 32 (1978) 3–16.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. “The Old Testament Genealogies in Recent Research,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.12"
    }
  }, [_vm._v("JBL")])]), _vm._v(" 94 (1965) 169–89.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Wiseman, D. J. “Flying Serpents,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.39"
    }
  }, [_vm._v("TynBul")])]), _vm._v(" 23 (1972) 108–10.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Wright, G. E. “The Levites in Deuteronomy,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.11"
    }
  }, [_vm._v("VT")])]), _vm._v(" 4 (1954) 325–30.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Wright, G. R. H. “The Bronze Age Temple at Amman,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.20"
    }
  }, [_vm._v("ZAW")])]), _vm._v(" 78 (1966) 350–56.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Wüst, M. "), _c('i', [_vm._v("Untersuchungen zu den siedlungsgeographischen Texten des Alten Testaments")]), _vm._v(". Vol. I: "), _c('i', [_vm._v("Ostjordanland")]), _vm._v(". Wiesbaden: Reichert, 1975.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.40"
    }
  }), _vm._v("Yahuda, A. S. “The Name of Balaam’s Homeland,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.12"
    }
  }, [_vm._v("JBL")])]), _vm._v(" 64 (1945) 547–51.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Zannoi, A. E. “Balaam: International Seer/Wizard Prophet,” "), _c('i', [_vm._v("St. Luke’s Journal of Theology")]), _vm._v(" 22 (1978) 5–19.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Zohar, N. “Repentance and Purification: The Significance and Semantics of "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("ḥṭ’t")]), _vm._v(" in the Pentateuch,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.12"
    }
  }, [_vm._v("JBL")])]), _vm._v(" 107 (1988) 609–18.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Zuckschwerdt, E. “Zur literarischen Vorgeschichte des priesterlichen Nazir-Gesetzes (Num 6:1–8),” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.20"
    }
  }, [_vm._v("ZAW")])]), _vm._v(" 88 (1976) 191–205.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-237fec4a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/eer-nicot04nu-0015.vue
// module id = 96
// module chunks = 0